"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.JADEConfigurationEditor = void 0;
const monaco_editor_1 = require("monaco-editor");
const tippy_js_1 = __importDefault(require("tippy.js"));
const color_1 = __importDefault(require("color"));
const randomcolor_1 = __importDefault(require("randomcolor"));
require("tippy.js/dist/tippy.css");
// @ts-ignore - note: we must have the ./ in front here otherwise any build outside this directory (ex. documentation viewer) will fail
const floppy_disk_svg_1 = __importDefault(require("./icons/solid/floppy-disk.svg"));
// @ts-ignore - note: we must have the ./ in front here otherwise any build outside this directory (ex. documentation viewer) will fail
const rotate_left_svg_1 = __importDefault(require("./icons/solid/rotate-left.svg"));
// @ts-ignore - note: we must have the ./ in front here otherwise any build outside this directory (ex. documentation viewer) will fail
const rotate_right_svg_1 = __importDefault(require("./icons/solid/rotate-right.svg"));
// @ts-ignore - note: we must have the ./ in front here otherwise any build outside this directory (ex. documentation viewer) will fail
const chevron_right_svg_1 = __importDefault(require("./icons/solid/chevron-right.svg"));
// @ts-ignore - note: we must have the ./ in front here otherwise any build outside this directory (ex. documentation viewer) will fail
const magnifying_glass_plus_svg_1 = __importDefault(require("./icons/regular/magnifying-glass-plus.svg"));
// @ts-ignore - note: we must have the ./ in front here otherwise any build outside this directory (ex. documentation viewer) will fail
const book_sparkles_svg_1 = __importDefault(require("./icons/solid/book-sparkles.svg"));
// @ts-ignore - note: we must have the ./ in front here otherwise any build outside this directory (ex. documentation viewer) will fail
const align_left_svg_1 = __importDefault(require("./icons/solid/align-left.svg"));
// @ts-ignore - note: we must have the ./ in front here otherwise any build outside this directory (ex. documentation viewer) will fail
const arrow_turn_down_left_svg_1 = __importDefault(require("./icons/solid/arrow-turn-down-left.svg"));
// @ts-ignore - note: we must have the ./ in front here otherwise any build outside this directory (ex. documentation viewer) will fail
const circle_xmark_svg_1 = __importDefault(require("./icons/solid/circle-xmark.svg"));
// @ts-ignore - note: we must have the ./ in front here otherwise any build outside this directory (ex. documentation viewer) will fail
const triangle_exclamation_svg_1 = __importDefault(require("./icons/solid/triangle-exclamation.svg"));
// @ts-ignore - note: we must have the ./ in front here otherwise any build outside this directory (ex. documentation viewer) will fail
const square_info_svg_1 = __importDefault(require("./icons/solid/square-info.svg"));
// @ts-ignore - note: we must have the ./ in front here otherwise any build outside this directory (ex. documentation viewer) will fail
const chevron_up_svg_1 = __importDefault(require("./icons/solid/chevron-up.svg"));
// @ts-ignore - note: we must have the ./ in front here otherwise any build outside this directory (ex. documentation viewer) will fail
const chevron_down_svg_1 = __importDefault(require("./icons/solid/chevron-down.svg"));
// @ts-ignore - note: we must have the ./ in front here otherwise any build outside this directory (ex. documentation viewer) will fail
const arrow_down_from_dotted_line_svg_1 = __importDefault(require("./icons/solid/arrow-down-from-dotted-line.svg"));
// @ts-ignore - note: we must have the ./ in front here otherwise any build outside this directory (ex. documentation viewer) will fail
const circle_xmark_svg_2 = __importDefault(require("./icons/solid/circle-xmark.svg"));
// @ts-ignore - note: we must have the ./ in front here otherwise any build outside this directory (ex. documentation viewer) will fail
const xmark_svg_1 = __importDefault(require("./icons/solid/xmark.svg"));
// @ts-ignore - note: we must have the ./ in front here otherwise any build outside this directory (ex. documentation viewer) will fail
const copy_svg_1 = __importDefault(require("./icons/solid/copy.svg"));
const regex_1 = require("./regex");
class JADEConfigurationEditor {
    constructor(options) {
        this.fontFamily = 'Menlo, Monaco, "Courier New", monospace';
        this.footerBarHeight = 20;
        this.footerBarMessageHeight = 25;
        this.footerBarFontSize = 11;
        this.footerBarErrorColor = '#FFF';
        this.footerBarIsExpanded = false;
        this.footerBarDefaultExpansionHeight = 150;
        this.footerBarIsMaintainingScrollToBottom = false;
        this.isEditingName = false;
        this.escapeKeyLiftedUpWhileEditingName = false;
        this.menubarHeight = 30;
        this.spacerWidth = 5;
        this.numFoldLevelsToDisplay = 7;
        this.notifications = [];
        this.footerBarMessages = [];
        this.regexHelperIdUniquenessCounter = 0;
        this.regexHelperMatchingSchemas = {};
        this.regexHelperViews = {};
        this.menubarRightSideItems = [
            {
                method: 'openDocumentation',
                iconSrc: book_sparkles_svg_1.default,
                tooltipText: 'Open Plugin Documentation (Ctrl + D)'
            },
            null,
            {
                method: 'wordWrap',
                iconSrc: arrow_turn_down_left_svg_1.default,
                tooltipText: 'Word Wrap (Alt + Z)'
            },
            null,
            {
                method: 'formatDocument',
                iconSrc: align_left_svg_1.default,
                tooltipText: 'Format (Alt + F)'
            },
            null,
            {
                method: 'undo',
                iconSrc: rotate_left_svg_1.default,
                tooltipText: 'Undo (Ctrl + Z)'
            },
            null,
            {
                method: 'redo',
                iconSrc: rotate_right_svg_1.default,
                tooltipText: 'Redo (Ctrl + Y)'
            },
            null,
            {
                method: 'saveContent',
                iconSrc: floppy_disk_svg_1.default,
                tooltipText: 'Save (Ctrl + S)'
            }
        ];
        this.menubarGutterAlignedItems = [
            {
                method: 'zoom',
                iconSrc: magnifying_glass_plus_svg_1.default,
                tooltipText: 'Zoom (Ctrl + -/+)'
            },
            null,
            {
                method: 'setFoldingLevel',
                iconSrc: chevron_right_svg_1.default,
                tooltipText: 'Folding (Alt + Num)'
            }
        ];
        this.schemaUri = options.schemaUri === undefined ? 'https://sixclear.com/jade/schemas/undefined.json' : options.schemaUri; // having this be a class member may or may not make sense, but for now we'll do it to allow schema updates (see the setJsonSchema() method) to default to this uri, which is really just a unique identifier for the schema, and since we only support one schema at the moment, this should be fine.
        this.rootDOM = options.rootElement;
        this.scrollContextElement = options.scrollContextElement;
        this.name = options.name === undefined ? 'Untitled' : options.name;
        this.nameOnFocus = this.name;
        this.nameEditable = options.nameEditable === undefined ? true : options.nameEditable;
        this.contentEditable = options.contentEditable === undefined ? true : options.contentEditable;
        this.lastSavedContent = options.content === undefined ? '{}' : options.content;
        this.jsonSchema = options.schema === undefined ? {} : options.schema;
        this.pluginType = options.pluginType;
        this.pluginVersionSelected = options.pluginVersionSelected;
        this.pluginVersions = options.pluginVersions;
        this.initialNotifications = options.initialNotifications === undefined ? [] : options.initialNotifications;
        this.hideVersionDropdown = options.hideVersionDropdown === undefined ? false : options.hideVersionDropdown;
        this.invalidNameRegex = /[\.\[\]\b\f\n\r\t\"\/\\]/g; // don't allow the following characters: . [ ] <backspace> <form feed> <line feed> <carriage return> <tab> " / \
        this.regexLineRegex = /^(\s*"[\s\w\d_-]+[Rr][Ee][Gg][Ee][Xx][\s\w\d_-]*"\s*:\s*)("[^\n]*")[,\s]*$/;
        this.theme = options.theme !== undefined ? options.theme : "vs-dark";
        this.backgroundColor = this.theme.startsWith('vs-dark') ? 'rgb(30, 30, 30)' : '#FFF';
        this.menubarBackgroundColor = this.theme === 'vs-dark' ? 'rgba(38, 79, 120, 0.3)' : 'rgba(173, 214, 255, 0.3)';
        this.menubarBorderColor = this.theme === 'vs-dark' ? '#858585' : '#237893';
        this.menubarButtonBackgroundColor = this.theme === 'vs-dark' ? '#1e1e1e' : '#FFF';
        this.menubarButtonHighlightColor = this.theme === 'vs-dark' ? 'rgba(38, 79, 120, 0.3)' : 'rgba(173, 214, 255, 0.3)';
        this.menubarIconColor = this.theme === 'vs-dark' ? '#9cdcfe' : '#0451a5';
        this.menubarNameInputBackgroundColor = this.theme === 'vs-dark' ? '#1e1e1e' : '#FFF';
        this.errorColor = this.theme === 'vs-dark' ? '#f48771' : '#e51400';
        this.warningColor = this.theme === 'vs-dark' ? '#f4c971' : '#e58700';
        this.noteColor = this.theme === 'vs-dark' ? '#71def4' : '#00d1e5';
        this.notificationColor = this.theme === 'vs-dark' ? '#FFF' : '#FFF';
        this.notificationCounter = 0;
        this.nameErrorNotificationId = '';
        this.contentInvalidJSONCNotificationId = '';
        this.footerStatusDefaultColor = this.theme === 'vs-dark' ? '#AAA' : '#CCC';
        this.iconActiveColor = this.theme === 'vs-dark' ? '#ce9178' : '#a31515';
        const footerMessagesScrollbarTrackBackgroundColor = this.theme === 'vs-dark' ? '#1e1e1e' : '#FFF';
        const footerMessagesScrollBarTrackBorderColor = this.theme === 'vs-dark' ? '#333' : '#CDCDCD';
        const footerMessagesScrollBarThumbColor = this.theme === 'vs-dark' ? 'rgba(121, 121, 121, .4)' : 'rgba(100, 100, 100, .4)';
        const footerMessagesScrollBarThumbHoverColor = this.theme === 'vs-dark' ? 'rgba(100, 100, 100, .7)' : 'rgba(100, 100, 100, .7)';
        const styleElement = document.createElement('style');
        styleElement.innerHTML = `
            .footer-bar-messages::-webkit-scrollbar {
                display: block !important;
                width: 14px;
                height: 28px;
                background-color: ${footerMessagesScrollbarTrackBackgroundColor};
                border-left: 1px solid ${footerMessagesScrollBarTrackBorderColor};
            }

            .footer-bar-messages::-webkit-scrollbar-thumb {
                background: ${footerMessagesScrollBarThumbColor};
            }

            .footer-bar-messages::-webkit-scrollbar-thumb:hover {
                background: ${footerMessagesScrollBarThumbHoverColor};
            }

            .tippy-box[data-theme~='jade'] {
                font-size: 11px;
                background-color: ${this.menubarIconColor};
                color: ${this.menubarButtonBackgroundColor};
            }

            .tippy-box[data-theme~='regex-copy-message'] {
                font-size: 11px;
                background-color: #1e1e1e;
                color: white;
            }

            .tippy-box[data-theme~='regex-copy-message'][data-placement^='top'] > .tippy-arrow::before {
                border-top-color: #1e1e1e;
            }

            .tippy-box .fold-level {
                font-size: ${this.menubarHeight / 2}px;
                padding: 4px;
                cursor: pointer;
                border-radius: 3px;
            }

            .tippy-box .fold-level:hover {
                background: ${this.menubarBackgroundColor};
            }

            .tippy-box .zoom-direction {
                font-size: ${this.menubarHeight / 2}px;
                padding: 4px;
                cursor: pointer;
                border-radius: 3px;
            }

            .tippy-box .zoom-direction:hover {
                background: ${this.menubarBackgroundColor};
            }

            .tippy-box .documentation-item {
                font-size: ${this.menubarHeight / 2}px;
                padding: 4px 6px;
                cursor: pointer;
                border-radius: 3px;
            }

            .tippy-box .documentation-item:hover {
                background: ${this.menubarBackgroundColor};
            }

            .tippy-box .version {
                font-size: ${this.menubarHeight / 2}px;
                padding: 4px;
                cursor: pointer;
                border-radius: 3px;
            }

            .tippy-box .version:hover {
                background: ${this.menubarBackgroundColor};
            }

            .tippy-box[data-theme~='jade'][data-placement^='bottom'] > .tippy-arrow::before {
                border-bottom-color: ${this.menubarIconColor};
            }

            #instance-name:focus {
                outline: none;
            }

            .notification-list-overlay::-webkit-scrollbar {
                display: none;
            }

            #plugin-version-selector svg {
                width: ${this.menubarHeight * .4}px;
                height: ${this.menubarHeight * .4}px;
                fill: ${this.menubarIconColor};
            }

            .regex-line {
                color: #333;
                background: rgba(156, 220, 254, .9);
                display: flex;
                align-items: center;
                justify-content: center;
                cursor: pointer;
                border-bottom-right-radius: 3px;
            }

            .regex-line::before {
                content: '(.*)';
                font-size: 10px;
                text-align: center;
            }

            .regex-line:hover {
                color: white;
            }

            .regex-helper-view {
                overflow-y: hidden;
                position: relative;
                z-index: 9999;
                padding: 10px 10px 10px 0;
                background: rgba(156, 220, 254, .9);
                box-sizing: border-box;
                border-top-right-radius: 5px;
                border-bottom-right-radius: 5px;
            }

            .regex-helper-view-close-button {
                position: absolute;
                top: 0;
                right: 0;
                width: 10px;
                height: 10px;
                padding: 10px 10px 20px 20px;
                color: #333;
                cursor: pointer;
            }

            .regex-helper-margin-view {
                background: rgba(156, 220, 254, .9);
                padding: 10px 5px;
                box-sizing: border-box;
                border-top-left-radius: 5px;
                border-bottom-left-radius: 5px;
            }

            .regex-helper-margin-view-container {
                display: grid;
                gap: 10px;
                width: 100%;
                height: 100%;
                grid-template-columns: 1fr;
                grid-template-rows: auto auto;
            }

            .regex-helper-view-container {
                display: grid;
                gap: 10px;
                /* width: 100%; */
                height: 100%;
                grid-template-columns: auto 250px;
                grid-template-rows: auto auto;
            }

            .subject-string-container {
                grid-row: 1;
                grid-column: 1 / span 1;
                background: #333;
            }

            .subject-string-label {
                color: #333;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 11px;
                text-align: center;
            }

            .regex-input-container {
                grid-row: 2;
                grid-column: 1 / span 1;
                background: #333;
            }

            .regex-input-label {
                color: #333;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 11px;
                text-align: center;
            }

            .regex-matches-container {
                grid-row: 1 / span 2;
                grid-column: 2 / span 1;
                padding-left: 10px;
            }

            .regex-match-label {
                color: #333;
                font-size: 11px;
                margin-top: 10px;
            }

            .regex-match-display {
                color: #333;
                padding: 10px 20px 10px 0;
            }

            .regex-submatches-display {
                color: #333;
                padding: 10px 20px 10px 0;
                overflow-y: scroll;
            }

            .regex-helper-match {
                font-family: var(--monaco-monospace-font);
                font-size: 14px;
                padding: 5px 10px;
                border-radius: 3px;
                background: #1e1e1e;
                color: white;
                border: 1px solid rgb(42, 35, 248);
            }

            .regex-helper-match-not-found {
                font-family: var(--monaco-monospace-font);
                font-size: 14px;
                padding: 5px 10px;
                background: #1e1e1e;
                border-radius: 3px;
                border: 1px solid rgb(251, 28, 65);
                color: rgb(251, 28, 65);
            }

            .regex-helper-submatch {
                font-family: var(--monaco-monospace-font);
                font-size: 14px;
                margin-bottom: 5px;
                border-radius: 3px;
                display: flex;
                gap: 10px;
                align-items: center;
                justify-content: flex-start;
                overflow: hidden;
            }

            .regex-helper-submatch > div.copy-button {
                width: 20px;
                height: 20px;
                padding: 5px;
                margin-left: auto;
                cursor: pointer;
            }

            .regex-helper-submatch > div.index {
                min-width: 20px;
                min-height: 20px;
                padding: 5px;
                color: #1e1e1e;
                display: flex;
                align-items: center;
                justify-content: center;
            }

        `;
        document.head.appendChild(styleElement);
        this.rootDOM.style.backgroundColor = this.menubarButtonBackgroundColor;
        this.rootDOM.style.fontFamily = this.fontFamily;
        if (this.rootDOM.style.position !== 'relative' && this.rootDOM.style.position !== 'absolute') {
            this.rootDOM.style.position = 'relative';
        }
        // configure editor element
        this.editorDOM = document.createElement('div');
        this.editorDOM.style.position = 'absolute';
        this.editorDOM.style.top = `${this.menubarHeight + 1}px`;
        this.editorDOM.style.right = '0px';
        this.editorDOM.style.left = '0px';
        this.editorDOM.style.bottom = this.contentEditable === false ? '0px' : `${this.footerBarHeight}px`;
        // append editor to rootElement
        this.rootDOM.appendChild(this.editorDOM);
        // initialize editor
        this.monacoModelUri = monaco_editor_1.Uri.parse("https://sixclear.com/jade/schemas/configuration-editor.json");
        this.monacoModel = monaco_editor_1.editor.createModel(this.lastSavedContent, 'json', this.monacoModelUri);
        this.decorateSchemaWithFeatureParams(this.jsonSchema);
        monaco_editor_1.languages.json.jsonDefaults.setDiagnosticsOptions({
            validate: true,
            allowComments: true,
            schemaValidation: 'error',
            schemas: [{
                    uri: this.schemaUri,
                    fileMatch: [this.monacoModelUri.toString()],
                    schema: this.jsonSchema
                }]
        });
        const editorSingleton = JADEConfigurationEditor.getMonacoEditorSingleton();
        this.monacoEditor = editorSingleton.create(this.editorDOM, {
            model: this.monacoModel,
            readOnly: !this.contentEditable,
            // override the vs-dark theme to be our custom dark theme
            theme: (this.theme === 'vs-dark') ? 'vs-dark-extended' : this.theme,
            // renderIndentGuides: true,
            renderLineHighlight: 'line',
            scrollBeyondLastLine: false,
            showFoldingControls: 'always',
            "semanticHighlighting.enabled": true,
            language: 'json'
        });
        this.alignMenubarGutterAlignedSectionToGutter = this.alignMenubarGutterAlignedSectionToGutter.bind(this);
        this.monacoEditor.layout();
        this.monacoEditor.onDidContentSizeChange(this.alignMenubarGutterAlignedSectionToGutter);
        this.monacoModel.onDidChangeContent(this.onChange.bind(this));
        editorSingleton.onDidChangeMarkers(this.onMarkersChange.bind(this));
        this.applyRegexDecorations(this.getContent());
        // bind regex helper handlers
        this.onRegexHelperClick = this.onRegexHelperClick.bind(this);
        this.onRegexHelperMarginClick = this.onRegexHelperMarginClick.bind(this);
        // configure instance name section
        this.menubarNameDOM = document.createElement('div');
        this.menubarNameDOM.style.display = 'flex';
        this.menubarNameDOM.style.alignItems = 'center';
        this.menubarNameDOM.style.justifyContent = 'center';
        this.menubarNameDOM.style.position = 'absolute';
        this.menubarNameDOM.style.top = '0px';
        this.menubarNameDOM.style.right = '0px';
        this.menubarNameDOM.style.left = '0px';
        this.menubarNameDOM.style.paddingLeft = `${this.spacerWidth}px`;
        this.menubarNameDOM.style.paddingRight = `${this.spacerWidth}px`;
        this.menubarNameDOM.style.height = `${this.menubarHeight}px`;
        this.menubarNameDOM.style.backgroundColor = this.menubarBackgroundColor;
        this.menubarNameDOM.style.borderBottomWidth = '1px';
        this.menubarNameDOM.style.borderBottomStyle = 'solid';
        this.menubarNameDOM.style.borderBottomColor = this.menubarBorderColor;
        // append instance name section to menubar
        this.rootDOM.appendChild(this.menubarNameDOM);
        // configure menubar element
        this.menubarDOM = document.createElement('div');
        this.menubarDOM.style.display = 'flex';
        this.menubarDOM.style.pointerEvents = 'none';
        this.menubarDOM.style.alignItems = 'center';
        this.menubarDOM.style.position = 'absolute';
        this.menubarDOM.style.top = '0px';
        this.menubarDOM.style.right = '0px';
        this.menubarDOM.style.left = '0px';
        this.menubarDOM.style.paddingLeft = `${this.spacerWidth}px`;
        this.menubarDOM.style.paddingRight = `${this.spacerWidth}px`;
        this.menubarDOM.style.height = `${this.menubarHeight}px`;
        // append menubar to rootElement
        this.rootDOM.appendChild(this.menubarDOM);
        // configure gutter aligned section element
        this.menubarGutterAlignedSection = document.createElement('div');
        this.menubarGutterAlignedSection.style.display = 'flex';
        this.menubarGutterAlignedSection.style.alignItems = 'flex-end';
        this.menubarGutterAlignedSection.style.justifyContent = 'flex-end';
        this.menubarGutterAlignedSection.style.justifySelf = 'flex-start';
        this.menubarGutterAlignedSection.style.marginRight = 'auto';
        this.menubarGutterAlignedSection.style.pointerEvents = 'auto';
        // append gutter aligned section to menubar
        this.menubarDOM.appendChild(this.menubarGutterAlignedSection);
        // configured instance name input element
        this.menubarNameInput = document.createElement('input');
        this.menubarNameInput.id = 'instance-name';
        this.menubarNameInput.style.textAlign = 'center';
        this.menubarNameInput.style.backgroundColor = 'transparent';
        this.menubarNameInput.style.color = this.menubarIconColor;
        this.menubarNameInput.style.fontFamily = this.fontFamily;
        this.menubarNameInput.style.fontSize = `${this.menubarHeight / 2}px`;
        this.menubarNameInput.style.borderWidth = `1px`;
        this.menubarNameInput.style.borderStyle = ` solid`;
        this.menubarNameInput.style.borderRadius = '2px';
        this.menubarNameInput.value = this.name;
        // add instance name input events
        this.menubarNameInput.addEventListener('mouseover', this.onNameInputMouseOver.bind(this));
        this.menubarNameInput.addEventListener('mouseout', this.onNameInputMouseOut.bind(this));
        this.menubarNameInput.addEventListener('input', this.onNameInputChange.bind(this));
        this.menubarNameInput.addEventListener('focus', this.onNameInputFocus.bind(this));
        this.menubarNameInput.addEventListener('blur', this.onNameInputBlur.bind(this));
        this.menubarNameInput.addEventListener('keyup', this.onNameInputKeyUp.bind(this));
        // initialize to moused out rendering
        this.onNameInputMouseOut();
        this.menubarNameDOM.appendChild(this.menubarNameInput);
        // configure instance name shadow div used for calculating input width based on content
        this.menubarNameShadowElement = document.createElement('pre');
        this.menubarNameShadowElement.style.position = 'absolute';
        this.menubarNameShadowElement.style.width = 'auto';
        this.menubarNameShadowElement.style.top = `-9999px`;
        this.menubarNameShadowElement.style.left = `-9999px`;
        this.menubarNameShadowElement.style.textAlign = 'center';
        this.menubarNameShadowElement.style.fontFamily = this.fontFamily;
        this.menubarNameShadowElement.style.fontSize = `${this.menubarHeight / 2}px`;
        this.menubarNameShadowElement.style.borderWidth = `1px`;
        this.menubarNameShadowElement.style.borderStyle = ` solid`;
        this.menubarNameShadowElement.style.borderRadius = '2px';
        this.menubarNameShadowElement.style.padding = `2px 6px 2px 6px`;
        this.menubarNameShadowElement.innerText = this.name;
        // add instance name shadow element to rootElement
        this.rootDOM.appendChild(this.menubarNameShadowElement);
        // if we're not hiding the dropdown then construct it :)  Note that if it isn't constructed, it can't be clicked on, and therefore this object won't be rendered below
        this.menubarVersionSelector = undefined;
        this.versionSelectorTooltip = undefined;
        if (this.hideVersionDropdown === false) {
            this.menubarVersionSelector = document.createElement('span');
            this.menubarVersionSelector.id = 'plugin-version-selector';
            this.menubarVersionSelector.style.display = 'flex';
            this.menubarVersionSelector.style.alignItems = 'center';
            this.menubarVersionSelector.style.justifyContent = 'center';
            this.menubarVersionSelector.style.textAlign = 'center';
            this.menubarVersionSelector.style.backgroundColor = this.menubarButtonBackgroundColor;
            this.menubarVersionSelector.style.color = this.menubarIconColor;
            this.menubarVersionSelector.style.fontFamily = this.fontFamily;
            this.menubarVersionSelector.style.fontSize = `${this.menubarHeight / 2}px`;
            this.menubarVersionSelector.style.borderWidth = `1px`;
            this.menubarVersionSelector.style.borderStyle = ` solid`;
            this.menubarVersionSelector.style.borderRadius = '2px';
            this.menubarVersionSelector.style.cursor = 'pointer';
            this.menubarVersionSelector.style.padding = '0 5px';
            this.menubarVersionSelector.style.marginLeft = `${this.spacerWidth}px`;
            this.menubarVersionSelector.innerHTML = `
                <div style="color: ${this.menubarIconColor}; margin: 0 5px 0 0; display: block;">${this.pluginVersionSelected}</div>
                <div style="margin-top: -1px;">${chevron_down_svg_1.default}</div>
            `;
            this.menubarNameDOM.append(this.menubarVersionSelector);
            this.versionSelectorTooltip = (0, tippy_js_1.default)(`#${this.menubarVersionSelector.id}`, {
                content: this.generatePluginVersionsMenu(),
                interactive: true,
                allowHTML: true,
                theme: 'jade',
                appendTo: () => this.rootDOM,
                placement: 'bottom',
                hideOnClick: true,
                delay: [200, 200],
                trigger: (this.contentEditable) ? 'click' : undefined
            })[0];
        }
        // configure menubar right side section
        this.menubarRightSideSection = document.createElement('div');
        this.menubarRightSideSection.style.display = 'flex';
        this.menubarRightSideSection.style.alignContent = 'flex-end';
        this.menubarRightSideSection.style.marginLeft = 'auto';
        this.menubarRightSideSection.style.pointerEvents = 'auto';
        // append right side section to menubar
        this.menubarDOM.appendChild(this.menubarRightSideSection);
        // initialize render of menubar controls
        this.renderMenubarSection(this.menubarRightSideSection, this.menubarRightSideItems);
        this.renderMenubarSection(this.menubarGutterAlignedSection, this.menubarGutterAlignedItems);
        this.alignMenubarGutterAlignedSectionToGutter();
        const menubarRightSideSectionWidth = this.menubarRightSideSection.getBoundingClientRect().width;
        const menubarGutterAlignedSectionWidth = this.menubarGutterAlignedSection.getBoundingClientRect().width;
        if (this.contentEditable === true && menubarRightSideSectionWidth >= this.menubarRightSideSection.getBoundingClientRect().width) {
            this.menubarCenteringOffset = menubarRightSideSectionWidth;
        }
        else {
            this.menubarCenteringOffset = menubarGutterAlignedSectionWidth;
        }
        // initialize input size
        this.resolveAndSetNameInputWidth();
        // configure footerBar element
        this.footerBarDOM = document.createElement('div');
        this.footerBarDOM.style.cursor = 'ns-resize';
        this.footerBarDOM.style.display = 'flex';
        this.footerBarDOM.style.alignItems = 'center';
        this.footerBarDOM.style.justifyContent = 'flex-start';
        this.footerBarDOM.style.position = 'absolute';
        this.footerBarDOM.style.bottom = '0px';
        this.footerBarDOM.style.right = '0px';
        this.footerBarDOM.style.left = '0px';
        this.footerBarDOM.style.paddingLeft = `${this.spacerWidth}px`;
        this.footerBarDOM.style.paddingRight = `${this.spacerWidth}px`;
        this.footerBarDOM.style.height = `${this.footerBarHeight}px`;
        this.footerBarDOM.style.backgroundColor = this.menubarBackgroundColor;
        this.footerBarDOM.style.borderTopWidth = '1px';
        this.footerBarDOM.style.borderTopStyle = 'solid';
        this.footerBarDOM.style.borderTopColor = this.menubarBorderColor;
        // append footerBar to rootDOM
        this.rootDOM.appendChild(this.footerBarDOM);
        // handle footerBar mousedown
        this.footerBarDOM.addEventListener('mousedown', this.onFooterbarStartDrag.bind(this));
        // bind mousemove and mouseup handlers so we can easily remove their listeners in the drag flow
        this.onFooterbarDrag = this.onFooterbarDrag.bind(this);
        this.onFooterbarEndDrag = this.onFooterbarEndDrag.bind(this);
        // configure footerBar elements to container element
        this.footerIconSize = this.footerBarHeight * .7;
        this.footerBarStatusDOM = document.createElement('div');
        this.footerBarStatusDOM.style.display = 'flex';
        this.footerBarStatusDOM.style.alignItems = 'flex-start';
        this.footerBarStatusDOM.style.justifyContent = 'center';
        this.footerBarStatusDOM.style.cursor = 'pointer';
        this.footerBarStatusDOM.addEventListener('mousedown', (evt) => evt.stopPropagation());
        this.footerBarStatusDOM.addEventListener('click', this.onFooterbarExpandedStatusIconClick.bind(this));
        this.footerBarErrorCountDOM = document.createElement('div');
        this.footerBarWarningCountDOM = document.createElement('div');
        this.footerBarNoteCountDOM = document.createElement('div');
        // intialize footerBar status and append to footerBar
        this.footerBarDOM.appendChild(this.footerBarStatusDOM);
        this.initializeFooterBarStatus();
        this.footerBarMaintainScrollToBottomIconDOM = document.createElement('div');
        this.footerBarMaintainScrollToBottomIconDOM.id = 'maintain-footer-scroll-btn';
        this.footerBarMaintainScrollToBottomIconDOM.style.cursor = 'pointer';
        this.footerBarMaintainScrollToBottomIconDOM.style.display = 'flex';
        this.footerBarMaintainScrollToBottomIconDOM.style.alignItems = 'center';
        this.footerBarMaintainScrollToBottomIconDOM.style.alignSelf = 'flex-end';
        this.footerBarMaintainScrollToBottomIconDOM.style.marginLeft = 'auto';
        this.footerBarMaintainScrollToBottomIconDOM.style.marginRight = `${this.spacerWidth * 2}`;
        this.footerBarMaintainScrollToBottomIconDOM.style.justifyContent = 'center';
        this.footerBarMaintainScrollToBottomIconDOM.style.width = `${this.footerIconSize}px`;
        this.footerBarMaintainScrollToBottomIconDOM.style.height = `${this.footerBarHeight}px`;
        this.footerBarDOM.appendChild(this.footerBarMaintainScrollToBottomIconDOM);
        this.footerBarMaintainScrollToBottomIconDOM.addEventListener('click', this.onFooterbarMaintainScrollToBottomIconClick.bind(this));
        this.footerBarMaintainScrollToBottomTooltip = (0, tippy_js_1.default)(`#${this.footerBarMaintainScrollToBottomIconDOM.id}`, {
            theme: 'jade',
            appendTo: () => this.rootDOM,
            placement: 'top',
            hideOnClick: true,
            delay: [500, 200],
            trigger: 'mouseenter focus'
        })[0];
        this.renderFooterBarMaintainScrollToBottomIcon();
        // configure footerBar expand icon element
        this.footerBarExpandedStatusIconDOM = document.createElement('div');
        this.footerBarExpandedStatusIconDOM.id = 'expand-footer-btn';
        this.footerBarExpandedStatusIconDOM.style.cursor = 'pointer';
        this.footerBarExpandedStatusIconDOM.style.display = 'flex';
        this.footerBarExpandedStatusIconDOM.style.alignItems = 'center';
        this.footerBarExpandedStatusIconDOM.style.alignSelf = 'flex-end';
        this.footerBarExpandedStatusIconDOM.style.justifyContent = 'center';
        this.footerBarExpandedStatusIconDOM.style.width = `${this.footerIconSize}px`;
        this.footerBarExpandedStatusIconDOM.style.height = `${this.footerBarHeight}px`;
        // append footerBar expand icon element to footerBar and render contents
        this.footerBarDOM.appendChild(this.footerBarExpandedStatusIconDOM);
        this.footerBarExpandedStatusIconDOM.addEventListener('click', this.onFooterbarExpandedStatusIconClick.bind(this));
        this.footerExpandTooltip = (0, tippy_js_1.default)(`#${this.footerBarExpandedStatusIconDOM.id}`, {
            theme: 'jade',
            appendTo: () => this.rootDOM,
            placement: 'top',
            hideOnClick: true,
            delay: [500, 200],
            trigger: 'mouseenter focus'
        })[0];
        this.renderFooterBarExpandedStatusIcon();
        // configure footerBar errors list element
        this.footerBarMessagesList = document.createElement('div');
        this.footerBarMessagesList.classList.add('footer-bar-messages');
        this.footerBarMessagesList.style.left = '0px';
        this.footerBarMessagesList.style.position = 'absolute';
        this.footerBarMessagesList.style.overflowY = 'scroll';
        this.footerBarMessagesList.style.left = '0px';
        this.footerBarMessagesList.style.right = '0px';
        this.footerBarMessagesList.style.bottom = '0px';
        // render error list with height 0 initially so that the first error will not render over top of the footerBar (will be resized to show errors if they exist when the footer is exapnded or resized)
        this.clientYOnFooterStartDrag = 0; // initialize; this will be overwritten on mousedown
        this.renderFooterVerticalSizing(0);
        // append footerBar errors list element to rootDOM
        this.rootDOM.appendChild(this.footerBarMessagesList);
        this.footerBarMessagesListHeightOnFooterStartDrag = this.footerBarMessagesList.offsetHeight;
        this.editorDOMHeightOnStartDrag = this.editorDOM.offsetHeight;
        // configure notification list element
        this.notificationsList = document.createElement('div');
        this.notificationsList.classList.add('notification-list-overlay');
        this.notificationsList.style.position = 'absolute';
        this.notificationsList.style.pointerEvents = 'none';
        this.notificationsList.style.right = `${this.menubarHeight / 2}px`;
        this.notificationsList.style.top = `${this.menubarHeight}px`;
        this.notificationsList.style.bottom = `${this.footerBarHeight}px`;
        this.notificationsList.style.padding = `${this.menubarHeight / 2}px`;
        this.notificationsList.style.overflowY = 'scroll';
        this.notificationsList.style.zIndex = "100"; // this fixes an issue where - with the monaco editor v 0.50.0 at least - the notifications sit behind the codelens (zoomed out, scrollable section)
        this.setNotificationsWidth();
        // append notification list to rootDOM
        this.rootDOM.appendChild(this.notificationsList);
        // if we set a default fold level, fold to that level
        if (options.defaultFoldLevel) {
            this.defaultFoldLevel = options.defaultFoldLevel;
            this.setFoldingLevel(this.defaultFoldLevel);
        }
        if (this.nameEditable === false) {
            this.menubarNameInput.disabled = true;
        }
        // if content is not editable, hide controls that can edit and add overlay
        if (this.contentEditable === false) {
            this.menubarRightSideSection.style.display = 'none';
        }
        // add event listeners
        this.rootDOM.addEventListener('click', this.onBodyClick.bind(this));
        window.addEventListener('resize', this.onResize.bind(this));
        window.addEventListener('keydown', this.onKeyDown.bind(this));
        // display any initial notifications
        const N = this.initialNotifications.length;
        for (let i = 0; i < N; i++) {
            const initialNotification = this.initialNotifications[i];
            this.addNotification(initialNotification.message, initialNotification.type);
        }
        // add anything to this lookup
        this.pasteReplacementLookup = {
            // '\r': '\n', // carriage return --> line feed
            '\t': '    ',
            '\b': ' ',
            '\f': ' ' // form feed --> 1 space
            // greek
            // "Α": "(Alpha)",
            // "α": "(alpha)",
            // "Ν": "(Nu)",
            // "ν": "(nu)",
            // "Β": "(Beta)",
            // "β": "(beta)",
            // "Ξ": "(Xi)",
            // "ξ": "(xi)",
            // "Γ": "(Gamma)",
            // "γ": "(gamma)",
            // "Ο": "(Omicron)",
            // "ο": "(omicron)",
            // "Δ": "(Delta)",
            // "δ": "(delta)",
            // "Π": "(Pi)",
            // "π": "(pi)",
            // "Ε": "(Epsilon)",
            // "ε": "(epsilon)",
            // "Ρ": "(Rho)",
            // "ρ": "(rho)",
            // "Ζ": "(Zeta)",
            // "ζ": "(zeta)",
            // "Σ": "(Sigma)",
            // "σ": "(sigma)",
            // "Η": "(Eta)",
            // "η": "(eta)",
            // "Τ": "(Tau)",
            // "τ": "(tau)",
            // "Θ": "(Theta)",
            // "θ": "(theta)",
            // "Υ": "(Upsilon)",
            // "υ": "(upsilon)",
            // "Ι": "(Iota)",
            // "ι": "(iota)",
            // "Φ": "(Phi)",
            // "φ": "(phi)",
            // "Κ": "(Kappa)",
            // "κ": "(kappa)",
            // "Χ": "(Chi)",
            // "χ": "(chi)",
            // "Λ": "(Lambda)",
            // "λ": "(lambda)",
            // "Ψ": "(Psi)",
            // "ψ": "(psi)",
            // "Μ": "(Mu)",
            // "μ": "(mu)",
            // "Ω": "(Omega)",
            // "ω": "(omega)"
        };
        // note: this regex CANNOT use the 'g' flag or it'll keep track of the "last index" on consecutive uses and not work as desired for this use case.
        this.pasteAllowRegex = /[a-zA-Z0-9_<>,"'=:;`!@#$%&\?\/\~\r\n\.\^\*\{\}\[\]\(\)\-\+\|\\ ]/;
    }
    static getMonacoEditorSingleton() {
        if (this.monacoEditorInitialized === false) {
            const legend = {
                tokenTypes: [
                    "comment",
                    "string",
                    "keyword",
                    "number",
                    "regexp",
                    "operator",
                    "namespace",
                    "type",
                    "struct",
                    "class",
                    "interface",
                    "enum",
                    "typeParameter",
                    "function",
                    "member",
                    "macro",
                    "variable",
                    "parameter",
                    "property",
                    "label",
                    "jade"
                ],
                tokenModifiers: [
                    "declaration",
                    "documentation",
                    "readonly",
                    "static",
                    "abstract",
                    "deprecated",
                    "modification",
                    "async",
                    // jade modifiers
                    "variable.wrapper",
                    "variable.name",
                    "expr.returnType",
                    "expr.colon",
                    "expr.function",
                    "expr.ignore",
                ],
            };
            /** @type {(type: string)=>number} */
            function getType(type) {
                return legend.tokenTypes.indexOf(type);
            }
            /** @type {(modifier: string[]|string|null)=>number} */
            function getModifier(modifiers) {
                if (typeof modifiers === "string") {
                    modifiers = [modifiers];
                }
                if (Array.isArray(modifiers)) {
                    let nModifiers = 0;
                    for (let modifier of modifiers) {
                        const nModifier = legend.tokenModifiers.indexOf(modifier);
                        if (nModifier > -1) {
                            nModifiers |= (1 << nModifier) >>> 0;
                        }
                    }
                    return nModifiers;
                }
                else {
                    return 0;
                }
            }
            const tokenType_jade = getType('jade');
            const tokenPattern_jadeReturnType = /((?:(?:Float|Boolean|Integer|String)(?=:))?)(:?)([a-zA-Z0-9_]*)(\()/g;
            const tokenModifier_jadeExprReturnType = getModifier('expr.returnType');
            const tokenModifier_jadeExprColon = getModifier('expr.colon');
            const tokenModifier_jadeExprFunction = getModifier('expr.function');
            const tokenModifier_jadeIgnore = getModifier('expr.ignore');
            const tokenPattern_jadeVariable = /(\@[A-Z]+\{)([a-zA-Z0-9_\[\]\.]*)(\})/g;
            const tokenModifier_jadeVariableWrapper = getModifier('variable.wrapper');
            const tokenModifier_jadeVariableName = getModifier('variable.name');
            monaco_editor_1.languages.registerDocumentSemanticTokensProvider("json", {
                getLegend: function () {
                    return legend;
                },
                provideDocumentSemanticTokens: function (model, lastResultId, token) {
                    const lines = model.getLinesContent();
                    /** @type {number[]} */
                    const data = [];
                    let prevLine = 0;
                    let prevEndIndex = 0;
                    // keep in mind the regexes below may not match on a given line, but we expect that if there is a returnType match it'll match BEFORE a variable because return types apply to entire json elements to determine the type they resolve to after an expression is computed.
                    // also, one thing we do is to keep track of the latest / previous line which had a token, so that we can compute the delta line when we reach the next line which contains a token
                    for (let i = 0; i < lines.length; i++) {
                        const line = lines[i];
                        let match;
                        while ((match = tokenPattern_jadeReturnType.exec(line)) !== null) {
                            data.push(i - prevLine, // delta line
                            (i === prevLine) ? match.index - prevEndIndex : match.index, // delta position on line
                            match[1].length, tokenType_jade, tokenModifier_jadeExprReturnType, 0, // delta line
                            match[1].length, // delta position on line
                            match[2].length, tokenType_jade, tokenModifier_jadeExprColon, 0, // delta line
                            match[2].length, // delta position on line
                            match[3].length, tokenType_jade, tokenModifier_jadeExprFunction, 0, // delta line
                            match[3].length, // delta position on line
                            match[4].length, tokenType_jade, tokenModifier_jadeIgnore);
                            prevLine = i;
                            prevEndIndex = tokenPattern_jadeReturnType.lastIndex - 1; // remember that tokenPattern_jadeReturnType.lastIndex is the index immediately following the end of the full match
                        }
                        while ((match = tokenPattern_jadeVariable.exec(line)) !== null) {
                            data.push(i - prevLine, // delta line
                            (i === prevLine) ? match.index - prevEndIndex : match.index, // delta position on line
                            match[1].length, tokenType_jade, tokenModifier_jadeVariableWrapper, 0, // delta line
                            match[1].length, // delta position on line
                            match[2].length, tokenType_jade, tokenModifier_jadeVariableName, 0, // delta line
                            match[2].length, // delta position on line
                            match[3].length, tokenType_jade, tokenModifier_jadeVariableWrapper);
                            prevLine = i;
                            prevEndIndex = tokenPattern_jadeVariable.lastIndex - 1; // remember that tokenPattern_jadeVariable.lastIndex is the index immediately following the end of the full match
                        }
                    }
                    return {
                        data: new Uint32Array(data),
                        resultId: undefined,
                    };
                },
                releaseDocumentSemanticTokens: function (resultId) { },
            });
            monaco_editor_1.editor.defineTheme("vs-dark-extended", {
                base: "vs-dark",
                inherit: true,
                rules: [
                    { token: "", foreground: "c5947c", fontStyle: "" },
                    // SUPPORTS SEMANTIC TOKENS PROVIDER FOR JSON LANGUAGE TO MAINTAIN JSON PARSER CAPABILITIES BUT FURTHER HIGHLIGHT JADE VARIABLE AND EXPRESSION SYNTAX
                    // { token: "string.key.json", foreground: "ffffff", fontStyle: "" },
                    { token: "keyword.json", foreground: "4095FF", fontStyle: "" },
                    { token: "string.value.json", foreground: "c5947c", fontStyle: "" },
                    { token: "jade.expr.returnType", foreground: "c976d1", fontStyle: "italic" },
                    { token: "jade.expr.colon", foreground: "cccccc", fontStyle: "italic" },
                    { token: "jade.expr.function", foreground: "00cc00", fontStyle: "italic" },
                    { token: "jade.expr.ignore", foreground: "c5947c", fontStyle: "" },
                    { token: "jade.variable.name", foreground: "4a9ef8", fontStyle: "italic" },
                    { token: "jade.variable.wrapper", foreground: "f9d849", fontStyle: "italic" },
                    // SUPPORTS MONARCH REGEX LANGUAGE HIGHLIGHTS
                    { token: "start", foreground: "aaaaaa", /* fontStyle: "bold" */ },
                    { token: "end", foreground: "aaaaaa" },
                    { token: "dot", foreground: "ffffff" },
                    { token: "quantity", foreground: "00bb00" },
                    { token: "named", foreground: "ff0000" },
                    { token: "parentheses", foreground: "ffff00" },
                    { token: "brackets", foreground: "bf80ff" },
                    { token: "escape", foreground: "99ccff" },
                    // SUPPORTS AN OLD ATTEMPT TO USE MONARCH TO HIGHLIGH JSON AND JADE VARIABLES (HOWEVER THIS IS INCOMPATIBLE WITH USING JSON AS THE LANGUAGE WHICH IS REQUIRED TO GET JSON PARSER CAPABILITIES)
                    // { token: "text", foreground: "ee8080" },
                    // { token: "comment", foreground: "74985d" },
                    // { token: "comma", foreground: "dddddd" },
                    // { token: "colon", foreground: "dddddd" },
                    // { token: "brackets", foreground: "dddddd" },
                    // { token: "curlies", foreground: "f9d849" },
                    // { token: "parentheses", foreground: "c976d1" },
                    // { token: "key", foreground: "aadbfb" },
                    // // { token: "string", foreground: "c5947c" }, // strings are colored by the base editor foreground color
                    // { token: "boolean", foreground: "4a9ef8" },
                    // { token: "number", foreground: "b5cea8" },
                    // { token: "var-name", foreground: "4a9ef8", fontStyle: "italic" },
                    // { token: "var-wrap", foreground: "f9d849", fontStyle: "italic" },
                    // { token: "return-type", foreground: "c976d1", fontStyle: "italic" },
                ],
                colors: {
                    "editor.foreground": "c5947c", // this colors strings for the regex use case (Monarch) but is overriden in the json use case (semantic tokens provider by string.value.json and jade.expre.ignore)
                },
            });
            // Register regex language
            monaco_editor_1.languages.register({ id: "regexLanguage" });
            // Register a tokens provider for the language
            monaco_editor_1.languages.setMonarchTokensProvider("regexLanguage", {
                tokenizer: {
                    root: [
                        [/^\^/, "start"],
                        [/\$$/, "end"],
                        [/\./, "dot"],
                        [/\*|\+|\?|\{\d+\}|\{\d+,\}|\{\d+,\d+}/, "quantity"],
                        // for some reason "named" MUST be before "parentheses"
                        [/\(\?\&[a-zA-Z\-]+\)/, "named"],
                        [/\(|\)/, "parentheses"],
                        [/\[|\]/, "brackets"],
                        // [/[a-zA-Z0-9\!\@\#\%\&\:\'\"\_\-]+/, "text"],
                        [/\\\\|\\x\d{2}|\\\d{3}|\\[a-zA-Z0-9\!\@\#\%\&\*\:\'\"\_\-\+\[\]\(\)\?]/, "escape"],
                    ],
                },
            });
            this.monacoEditorInitialized = true;
        }
        return monaco_editor_1.editor;
    }
    // note that we can pass multiple schemas and probably should at some point when we break out common sub-schemas for defining various plugin options.  for now, however, we have a singular semantic going both on construction and here with this function
    setJsonSchema(jsonSchema, version, schemaUri) {
        schemaUri = (schemaUri === undefined) ? this.schemaUri : schemaUri;
        this.decorateSchemaWithFeatureParams(jsonSchema);
        // this reloads schemas, you can add/modify and remove schemas this way
        monaco_editor_1.languages.json.jsonDefaults.setDiagnosticsOptions({
            validate: true,
            allowComments: true,
            schemaValidation: 'error',
            schemas: [{
                    uri: schemaUri,
                    fileMatch: [this.monacoModelUri.toString()],
                    schema: jsonSchema
                }]
        });
        this.setSelectedPluginVersion(version);
    }
    setFooterMessages(messages) {
        this.footerBarMessages = messages;
        this.renderFooterBar();
        if (this.footerBarIsMaintainingScrollToBottom) {
            this.scrollFooterMessagesToBottom();
        }
    }
    clearFooterMessages() {
        this.footerBarMessages = [];
        this.renderFooterBar();
    }
    // returns the notification id which can be used to remove the notification (see method: removeNotification(id) )
    addNotification(message, type, lifetime = -1) {
        this.notificationCounter += 1;
        const id = this.notificationCounter.toString();
        this.notifications.push({
            id,
            message,
            type,
            lifetime
        });
        this.renderNotifications();
        // if we have a valid id and lifetime isn't -1 ("forever") then set the notification to remove after lifetime ms expires
        if (lifetime >= 0) {
            setTimeout(() => {
                this.removeNotification(id);
            }, lifetime);
        }
        return id;
    }
    removeNotification(id) {
        const N = this.notifications.length;
        for (let i = 0; i < N; i++) {
            if (this.notifications[i].id === id) {
                this.notifications.splice(i, 1);
                break;
            }
        }
        this.renderNotifications();
    }
    isContentValidJSONC() {
        // we can simply try to build a function from that content and return it as an object
        try {
            var func = new Function("return " + this.getContent());
            // if we get here, the contents of jsonc was a valid javascript type at least, otherwise we could have jumped to the catch block with an error
            // now let's check if it's a function
            if (typeof func === 'function') {
                // if we get here, then jsonc was valid json with comments - allow saving the config editor contents - yay!
                return true;
            }
            else {
                // if we get here, config was not a valid json object with comments, so we had an invalid config
                // just fall through to return false
            }
        }
        catch (error) {
            // if the function wasn't valid, then config could not have been valid json with comments , so we had an invalid config
            // just fall through to return false
        }
        return false;
    }
    saveContent() {
        var _a, _b;
        try {
            if (this.isContentValidJSONC()) {
                this.removeNotification(this.contentInvalidJSONCNotificationId);
                this.lastSavedContent = this.getContent();
                if (((_b = (_a = window) === null || _a === void 0 ? void 0 : _a.chrome) === null || _b === void 0 ? void 0 : _b.webview) !== undefined) {
                    // @ts-ignore
                    window.chrome.webview.postMessage({
                        status: 'OK',
                        operation: 'saveContent',
                        data: {
                            isValid: this.isContentValid(),
                            content: this.lastSavedContent
                        }
                    });
                }
            }
            else {
                // remove this notification if it exists since we only want to show one at a time (we'll add one below)
                this.removeNotification(this.contentInvalidJSONCNotificationId);
                const message = `The content was not valid JSON (with optional comments) and therefore could not be saved.\n\nUpdate the content to be valid JSON (with optional comments) before saving.`;
                this.contentInvalidJSONCNotificationId = this.addNotification(message, 'error');
            }
        }
        catch (error) {
            console.error(error);
        }
    }
    setContent(content) {
        this.monacoModel.setValue(content);
        if (this.defaultFoldLevel !== undefined) {
            this.setFoldingLevel(this.defaultFoldLevel);
        }
    }
    getContent() {
        return this.monacoModel.getValue();
    }
    isContentValid() {
        for (let i = 0; i < this.footerBarMessages.length; i++) {
            const message = this.footerBarMessages[i];
            if (message.type === 'error') {
                return false;
            }
        }
        return true;
    }
    getName() {
        return this.name;
    }
    setSelectedPluginVersion(version) {
        if (this.menubarVersionSelector !== undefined) {
            this.pluginVersionSelected = version;
            this.menubarVersionSelector.children[0].innerText = version;
        }
    }
    setPluginVersions(versions) {
        if (this.contentEditable) {
            this.pluginVersions = versions;
            if (this.versionSelectorTooltip !== undefined) {
                this.versionSelectorTooltip.setContent(this.generatePluginVersionsMenu());
            }
            else {
                console.log('We did not expect to get this line of code.  It should not be possible if this.versionSelectorTooltip is not defined in the first place.');
            }
        }
    }
    isValidName(name) {
        return name.search(this.invalidNameRegex) === -1;
    }
    setName(name) {
        if (this.isValidName(name)) {
            this.updateUI_inputNameValid();
            this.name = name;
            this.menubarNameInput.value = this.name;
            this.menubarNameShadowElement.innerText = this.name;
            this.postNameChangedMessage();
        }
        else {
            this.updateUI_inputNameInvalid(name);
        }
    }
    getIsEditingName() {
        return this.isEditingName;
    }
    isLiveEditNameValid() {
        const liveEditName = this.menubarNameInput.value.trimStart().trimEnd();
        return this.isValidName(liveEditName);
    }
    getLiveEditName() {
        return this.menubarNameInput.value.trimStart().trimEnd();
    }
    undo() {
        this.monacoEditor.trigger(this.monacoModelUri.toString(), 'undo', null);
    }
    redo() {
        this.monacoEditor.trigger(this.monacoModelUri.toString(), 'redo', null);
    }
    formatDocument() {
        this.monacoEditor.trigger(this.monacoModelUri.toString(), 'editor.action.formatDocument', null);
    }
    wordWrap() {
        const currentValue = this.monacoEditor.getOption(monaco_editor_1.editor.EditorOption.wordWrap);
        switch (currentValue) {
            case 'on':
            case 'bounded':
            case 'wordWrapColumn':
                this.monacoEditor.updateOptions({ wordWrap: 'off' });
                break;
            case 'off':
                this.monacoEditor.updateOptions({ wordWrap: 'on' });
                break;
            default:
                break;
        }
    }
    render() {
        this.setNotificationsWidth();
        this.renderFooterBar();
        this.monacoEditor.layout();
        this.resolveAndSetNameInputWidth();
        this.monacoEditor.changeViewZones((changeAccessor) => {
            const layoutInfo = this.monacoEditor.getLayoutInfo();
            Object.values(this.regexHelperViews).forEach((regexHelperView) => {
                const viewWidth = layoutInfo.minimap.minimapLeft - layoutInfo.lineNumbersWidth - layoutInfo.glyphMarginWidth - layoutInfo.decorationsWidth;
                const editorWidths = viewWidth - 250 - 10;
                regexHelperView.zoneParams.domNode.style.width = `${viewWidth}px`;
                changeAccessor.layoutZone(regexHelperView.viewZoneId);
                const testStringContainerEl = regexHelperView.zoneParams.domNode.getElementsByClassName('subject-string-container')[0];
                const regexInputContainerEl = regexHelperView.zoneParams.domNode.getElementsByClassName('regex-input-container')[0];
                testStringContainerEl.style.width = `${editorWidths}px`;
                regexInputContainerEl.style.width = `${editorWidths}px`;
                const testStringContainerElBoundingRect = testStringContainerEl.getBoundingClientRect();
                const regexInputContainerElBoundingRect = regexInputContainerEl.getBoundingClientRect();
                regexHelperView.subjectStringEditor.layout({ width: editorWidths, height: testStringContainerElBoundingRect.height });
                regexHelperView.regexEditor.layout({ width: editorWidths, height: regexInputContainerElBoundingRect.height });
            });
        });
    }
    openDocumentation() {
        var _a, _b;
        try {
            if (((_b = (_a = window) === null || _a === void 0 ? void 0 : _a.chrome) === null || _b === void 0 ? void 0 : _b.webview) !== undefined) {
                // @ts-ignore
                window.chrome.webview.postMessage({
                    status: 'OK',
                    operation: 'openDocumentation',
                    data: {
                        contentType: 'plugins',
                        pluginType: this.pluginType,
                        pluginVersion: this.pluginVersionSelected
                    }
                });
            }
        }
        catch (error) {
            console.error(error);
        }
    }
    setFoldingLevel(level) {
        if (level === 0) {
            this.monacoEditor.trigger(this.monacoModelUri.toString(), `editor.unfoldAll`, null);
        }
        else {
            this.monacoEditor.trigger(this.monacoModelUri.toString(), `editor.foldLevel${level}`, null);
        }
    }
    setUnfolded() {
        this.setFoldingLevel(0);
    }
    destroy() {
        var _a;
        (_a = this.monacoEditor.getModel()) === null || _a === void 0 ? void 0 : _a.dispose();
        this.monacoEditor.dispose();
    }
    generatePluginVersionsMenu() {
        const versionMenu = this.pluginVersions.map((version) => {
            return `
                <div class="version" data-version="${version}">${version}</div>
            `;
        });
        return `
            <div>
                ${versionMenu.join('')}
            </div>
        `;
    }
    renderMenubarSection(sectionElement, items) {
        for (let i = 0; i < items.length; i++) {
            const menuItemConfig = items[i];
            if (menuItemConfig !== null) {
                const buttonElement = document.createElement('div');
                const id = `menu-item-${menuItemConfig.method}`;
                buttonElement.id = id;
                buttonElement.style.cursor = 'pointer';
                buttonElement.style.display = 'flex';
                buttonElement.style.alignItems = 'center';
                buttonElement.style.justifyContent = 'center';
                buttonElement.style.width = `${this.menubarHeight * .7}px`;
                buttonElement.style.height = `${this.menubarHeight * .7}px`;
                buttonElement.style.backgroundColor = this.menubarButtonBackgroundColor;
                buttonElement.innerHTML = menuItemConfig.iconSrc;
                sectionElement.appendChild(buttonElement);
                const svg = buttonElement.getElementsByTagName('svg')[0];
                svg.style.width = `${this.menubarHeight * .4}px`;
                svg.style.height = `${this.menubarHeight * .4}px`;
                svg.style.fill = this.menubarIconColor;
                svg.style.shapeRendering = 'geometricPrecision';
                if (menuItemConfig.method === 'setFoldingLevel') {
                    let foldMenu = '';
                    for (let level = 0; level < this.numFoldLevelsToDisplay; level++) {
                        if (level === 0) {
                            foldMenu += `<div class="fold-level" data-level="${level}">&nbsp;&nbsp;Unfold All&nbsp;&nbsp;&nbsp;${level}</div>`;
                        }
                        else {
                            foldMenu += `<div class="fold-level" data-level="${level}">&nbsp;&nbsp;Fold Level&nbsp;&nbsp;&nbsp;${level}</div>`;
                        }
                    }
                    this.foldLevelTooltip = (0, tippy_js_1.default)(`#${id}`, {
                        content: `<div>
                            <div style="border-bottom: 1px solid ${this.menubarBorderColor}; padding-bottom: 3px; font-weight: bold; font-size: ${this.menubarHeight / 2}px;">${menuItemConfig.tooltipText}</div>
                            ${foldMenu}
                        </div>`,
                        interactive: true,
                        allowHTML: true,
                        theme: 'jade',
                        appendTo: () => this.rootDOM,
                        placement: 'bottom',
                        hideOnClick: true,
                        delay: [200, 200],
                        trigger: 'mouseenter click focus'
                    })[0];
                }
                else if (menuItemConfig.method === 'zoom') {
                    const zoomMenu = `
                        <div class="zoom-direction" data-direction="in">Zoom In&nbsp; (Ctrl + <strong>+</strong>)</div>
                        <div class="zoom-direction" data-direction="out">Zoom Out (Ctrl + <strong>-</strong>)</div>
                    `;
                    this.zoomTooltip = (0, tippy_js_1.default)(`#${id}`, {
                        content: `<div>
                            ${zoomMenu}
                        </div>`,
                        interactive: true,
                        allowHTML: true,
                        theme: 'jade',
                        appendTo: () => this.rootDOM,
                        placement: 'bottom',
                        hideOnClick: true,
                        delay: [200, 200],
                        trigger: 'mouseenter click focus'
                    })[0];
                }
                else {
                    (0, tippy_js_1.default)(`#${id}`, {
                        content: menuItemConfig.tooltipText,
                        theme: 'jade',
                        appendTo: () => this.rootDOM,
                        placement: 'bottom',
                        hideOnClick: true,
                        delay: [500, 200],
                        trigger: 'mouseenter focus'
                    });
                    buttonElement.addEventListener('pointerover', (evt) => {
                        buttonElement.style.backgroundColor = this.menubarButtonHighlightColor;
                    });
                    buttonElement.addEventListener('pointerout', (evt) => {
                        buttonElement.style.backgroundColor = this.menubarButtonBackgroundColor;
                    });
                    buttonElement.addEventListener('pointerup', (evt) => {
                        if (menuItemConfig.method !== 'setFoldingLevel' && menuItemConfig.method !== 'zoom') {
                            this[menuItemConfig.method](); // this is the click handler essentially... call the method defined in the right side menubar config if we get here
                        }
                    });
                }
            }
            else {
                const spacerElement = document.createElement('div');
                spacerElement.style.width = `${this.spacerWidth}px`;
                sectionElement.appendChild(spacerElement);
            }
        }
    }
    renderNotifications() {
        this.notificationsList.innerHTML = '';
        for (let i = 0; i < this.notifications.length; i++) {
            const notification = this.notifications[i];
            const notificationElement = document.createElement('div');
            notificationElement.style.position = 'relative';
            notificationElement.style.borderRadius = '6px';
            notificationElement.style.marginBottom = '10px';
            notificationElement.style.pointerEvents = 'auto';
            switch (notification.type) {
                case 'error':
                    notificationElement.style.backgroundColor = this.errorColor;
                    break;
                case 'warning':
                    notificationElement.style.backgroundColor = this.warningColor;
                    break;
                case 'note':
                    notificationElement.style.backgroundColor = this.noteColor;
                    break;
            }
            const messageElement = document.createElement('pre');
            messageElement.style.color = this.notificationColor;
            messageElement.style.margin = '0px';
            notificationElement.style.padding = '10px 20px 10px 10px';
            messageElement.style.whiteSpace = 'pre-wrap';
            messageElement.innerText = notification.message;
            const closeButton = document.createElement('div');
            closeButton.style.position = 'absolute';
            closeButton.style.top = '0px';
            closeButton.style.right = '0px';
            closeButton.style.cursor = 'pointer';
            closeButton.style.display = 'flex';
            closeButton.style.alignItems = 'center';
            closeButton.style.justifyContent = 'center';
            closeButton.style.width = `20px`;
            closeButton.style.height = `20px`;
            closeButton.innerHTML = circle_xmark_svg_2.default;
            const svg = closeButton.getElementsByTagName('svg')[0];
            svg.style.width = `10px`;
            svg.style.height = `10px`;
            svg.style.fill = this.notificationColor;
            svg.style.shapeRendering = 'geometricPrecision';
            closeButton.addEventListener('click', () => {
                this.notifications.splice(i, 1);
                this.renderNotifications();
            });
            notificationElement.appendChild(messageElement);
            notificationElement.appendChild(closeButton);
            this.notificationsList.appendChild(notificationElement);
        }
    }
    initializeFooterBarStatus() {
        ['error', 'warning', 'note'].forEach((type) => {
            const statusDOM = document.createElement('div');
            const iconDOM = document.createElement('div');
            const id = statusDOM.id = `${type}-status`;
            let countDOM, footerSvg;
            statusDOM.style.display = 'flex';
            statusDOM.style.padding = `0 ${this.spacerWidth} 0 ${this.spacerWidth}`;
            statusDOM.style.alignItems = 'center';
            statusDOM.style.justifyContent = 'center';
            switch (type) {
                case 'error':
                    iconDOM.innerHTML = circle_xmark_svg_1.default;
                    footerSvg = this.footerBarErrorIconSvg = iconDOM.getElementsByTagName('svg')[0];
                    this.footerBarErrorIconSvg.style.fill = this.footerStatusDefaultColor;
                    countDOM = this.footerBarErrorCountDOM;
                    countDOM.style.color = this.footerStatusDefaultColor;
                    break;
                case 'warning':
                    iconDOM.innerHTML = triangle_exclamation_svg_1.default;
                    footerSvg = this.footerBarWarningIconSvg = iconDOM.getElementsByTagName('svg')[0];
                    this.footerBarWarningIconSvg.style.fill = this.footerStatusDefaultColor;
                    countDOM = this.footerBarWarningCountDOM;
                    countDOM.style.color = this.footerStatusDefaultColor;
                    break;
                case 'note':
                    iconDOM.innerHTML = square_info_svg_1.default;
                    footerSvg = this.footerBarNoteIconSvg = iconDOM.getElementsByTagName('svg')[0];
                    this.footerBarNoteIconSvg.style.fill = this.footerStatusDefaultColor;
                    countDOM = this.footerBarNoteCountDOM;
                    countDOM.style.color = this.footerStatusDefaultColor;
                    break;
            }
            countDOM.style.paddingLeft = `${this.spacerWidth}px`;
            countDOM.style.fontSize = `${this.footerBarFontSize}px`;
            countDOM.innerText = '0';
            footerSvg.style.width = `${this.footerIconSize}px`;
            footerSvg.style.height = `${this.footerIconSize}px`;
            statusDOM.appendChild(iconDOM);
            statusDOM.appendChild(countDOM);
            this.footerBarStatusDOM.appendChild(statusDOM);
            (0, tippy_js_1.default)(`#${id}`, {
                content: `${type.charAt(0).toUpperCase()}${type.slice(1)}s`,
                theme: 'jade',
                appendTo: () => this.rootDOM,
                placement: 'top',
                hideOnClick: true,
                delay: [500, 200],
                trigger: 'mouseenter focus'
            });
        });
    }
    renderFooterBar() {
        this.renderFooterBarStatus();
        this.renderFooterBarExpandedStatusIcon();
        this.footerBarMessagesList.innerHTML = '';
        if (this.footerBarMessages.length !== 0) {
            this.footerBarMessagesList.innerHTML = '';
            for (let i = 0; i < this.footerBarMessages.length; i++) {
                const footerBarMessage = this.footerBarMessages[i];
                const footerBarMessageDOM = document.createElement('div');
                if (i !== 0) {
                    footerBarMessageDOM.style.borderTop = `1px solid ${this.menubarBorderColor}`;
                }
                if (footerBarMessage.onClick !== undefined) {
                    footerBarMessageDOM.style.cursor = 'pointer';
                    footerBarMessageDOM.addEventListener('click', footerBarMessage.onClick);
                }
                footerBarMessageDOM.style.display = 'flex';
                footerBarMessageDOM.style.padding = `3px ${this.spacerWidth}`;
                footerBarMessageDOM.style.alignItems = 'center';
                footerBarMessageDOM.style.fontSize = `${this.footerBarFontSize}px`;
                const duplicityDOM = document.createElement('div');
                const duplicityCountDOM = document.createElement('div');
                duplicityDOM.style.width = `30px`;
                duplicityDOM.style.minWidth = `30px`;
                duplicityDOM.style.display = 'flex';
                duplicityDOM.style.alignItems = 'flex-end';
                duplicityDOM.style.justifyContent = 'flex-end';
                duplicityDOM.style.alignSelf = 'flex-start';
                duplicityDOM.style.paddingRight = '3px';
                duplicityDOM.style.paddingBottom = '3px';
                duplicityDOM.style.paddingTop = '3px';
                if (footerBarMessage.duplicity > 1) {
                    duplicityCountDOM.innerText = footerBarMessage.duplicity.toString();
                    duplicityCountDOM.style.padding = `2px 3px 2px 3px`;
                    duplicityCountDOM.style.borderRadius = '20px';
                    duplicityCountDOM.style.color = this.backgroundColor;
                    duplicityDOM.appendChild(duplicityCountDOM);
                }
                else {
                    duplicityCountDOM.style.borderRadius = '20px';
                    duplicityCountDOM.style.color = this.backgroundColor;
                    duplicityCountDOM.style.width = `5px`;
                    duplicityCountDOM.style.height = `5px`;
                    duplicityDOM.appendChild(duplicityCountDOM);
                }
                duplicityDOM.appendChild(duplicityCountDOM);
                const removeButtonDOM = document.createElement('div');
                removeButtonDOM.style.width = `20px`;
                removeButtonDOM.style.display = 'flex';
                removeButtonDOM.style.alignItems = 'flex-end';
                removeButtonDOM.style.justifyContent = 'center';
                removeButtonDOM.style.alignSelf = 'flex-start';
                removeButtonDOM.style.paddingBottom = '3px';
                removeButtonDOM.style.paddingTop = '3px';
                let footerSvg;
                if (footerBarMessage.clearable === true) {
                    const iconDOM = document.createElement('div');
                    iconDOM.innerHTML = xmark_svg_1.default;
                    iconDOM.style.cursor = 'pointer';
                    footerSvg = iconDOM.getElementsByTagName('svg')[0];
                    footerSvg.style.width = `${this.footerIconSize}px`;
                    footerSvg.style.height = `${this.footerIconSize}px`;
                    removeButtonDOM.appendChild(iconDOM);
                    removeButtonDOM.addEventListener('click', () => {
                        this.onFooterMessageRemove(footerBarMessage);
                    });
                }
                switch (footerBarMessage.type) {
                    case 'error':
                        footerBarMessageDOM.style.color = this.errorColor;
                        duplicityCountDOM.style.backgroundColor = this.errorColor;
                        if (footerSvg) {
                            footerSvg.style.fill = this.errorColor;
                        }
                        break;
                    case 'warning':
                        footerBarMessageDOM.style.color = this.warningColor;
                        duplicityCountDOM.style.backgroundColor = this.warningColor;
                        if (footerSvg) {
                            footerSvg.style.fill = this.warningColor;
                        }
                        break;
                    case 'note':
                        footerBarMessageDOM.style.color = this.noteColor;
                        duplicityCountDOM.style.backgroundColor = this.noteColor;
                        if (footerSvg) {
                            footerSvg.style.fill = this.noteColor;
                        }
                        break;
                }
                footerBarMessageDOM.append(duplicityDOM);
                for (let i = 0; i < footerBarMessage.cells.length; i++) {
                    const cell = footerBarMessage.cells[i];
                    const cellDOM = document.createElement('div');
                    const messageWidth = this.rootDOM.clientWidth - 50;
                    cellDOM.style.width = `${messageWidth * cell.fraction}px`;
                    cellDOM.style.padding = `0 ${this.spacerWidth} 0 ${this.spacerWidth}`;
                    cellDOM.style.textOverflow = 'ellipsis';
                    cellDOM.style.overflow = 'hidden';
                    cellDOM.style.whiteSpace = 'nowrap';
                    cellDOM.innerText = cell.text;
                    footerBarMessageDOM.append(cellDOM);
                }
                footerBarMessageDOM.append(removeButtonDOM);
                this.footerBarMessagesList.appendChild(footerBarMessageDOM);
            }
        }
    }
    renderFooterBarStatus() {
        let errors = 0;
        let warnings = 0;
        let notes = 0;
        for (let i = 0; i < this.footerBarMessages.length; i++) {
            const message = this.footerBarMessages[i];
            switch (message.type) {
                case 'error':
                    errors += message.duplicity;
                    break;
                case 'warning':
                    warnings += message.duplicity;
                    break;
                case 'note':
                    notes += message.duplicity;
                    break;
            }
        }
        if (errors > 0) {
            this.footerBarErrorCountDOM.style.color = this.errorColor;
            this.footerBarErrorIconSvg.style.fill = this.errorColor;
        }
        else {
            this.footerBarErrorCountDOM.style.color = this.footerStatusDefaultColor;
            this.footerBarErrorIconSvg.style.fill = this.footerStatusDefaultColor;
        }
        if (warnings > 0) {
            this.footerBarWarningCountDOM.style.color = this.warningColor;
            this.footerBarWarningIconSvg.style.fill = this.warningColor;
        }
        else {
            this.footerBarWarningCountDOM.style.color = this.footerStatusDefaultColor;
            this.footerBarWarningIconSvg.style.fill = this.footerStatusDefaultColor;
        }
        if (notes > 0) {
            this.footerBarNoteCountDOM.style.color = this.noteColor;
            this.footerBarNoteIconSvg.style.fill = this.noteColor;
        }
        else {
            this.footerBarNoteCountDOM.style.color = this.footerStatusDefaultColor;
            this.footerBarNoteIconSvg.style.fill = this.footerStatusDefaultColor;
        }
        this.footerBarErrorCountDOM.innerText = errors.toString();
        this.footerBarWarningCountDOM.innerText = warnings.toString();
        this.footerBarNoteCountDOM.innerText = notes.toString();
    }
    renderFooterBarExpandedStatusIcon() {
        let footerSvg;
        if (this.footerBarIsExpanded) {
            this.footerBarExpandedStatusIconDOM.innerHTML = chevron_down_svg_1.default;
            footerSvg = this.footerBarExpandedStatusIconDOM.getElementsByTagName('svg')[0];
            this.footerExpandTooltip.setContent('Collapse Footer');
        }
        else {
            this.footerBarExpandedStatusIconDOM.innerHTML = chevron_up_svg_1.default;
            footerSvg = this.footerBarExpandedStatusIconDOM.getElementsByTagName('svg')[0];
            this.footerExpandTooltip.setContent('Expand Footer');
        }
        footerSvg.style.shapeRendering = 'geometricPrecision';
        footerSvg.style.fill = this.menubarIconColor;
        footerSvg.style.width = `${this.footerIconSize}px`;
        footerSvg.style.height = `${this.footerIconSize}px`;
    }
    renderFooterBarMaintainScrollToBottomIcon() {
        this.footerBarMaintainScrollToBottomIconDOM.innerHTML = arrow_down_from_dotted_line_svg_1.default;
        const footerSvg = this.footerBarMaintainScrollToBottomIconDOM.getElementsByTagName('svg')[0];
        if (this.footerBarIsMaintainingScrollToBottom) {
            footerSvg.style.fill = this.iconActiveColor;
            this.footerBarMaintainScrollToBottomTooltip.setContent('Unpin');
        }
        else {
            footerSvg.style.fill = this.menubarIconColor;
            this.footerBarMaintainScrollToBottomTooltip.setContent('Pin To Show Latest Messages');
        }
        footerSvg.style.shapeRendering = 'geometricPrecision';
        footerSvg.style.width = `${this.footerIconSize}px`;
        footerSvg.style.height = `${this.footerIconSize}px`;
    }
    renderFooterVerticalSizing(footerBarMessagesListHeight) {
        this.footerBarDOM.style.bottom = `${footerBarMessagesListHeight}px`;
        this.footerBarMessagesList.style.height = `${footerBarMessagesListHeight}px`;
        this.editorDOM.style.bottom = `${footerBarMessagesListHeight + this.footerBarHeight + 2}px`;
        this.monacoEditor.layout();
    }
    alignMenubarGutterAlignedSectionToGutter() {
        const gutter = document.getElementsByClassName('margin-view-overlays')[0];
        const gutterRect = gutter.getBoundingClientRect();
        this.menubarGutterAlignedSection.style.width = `${gutterRect.width - this.spacerWidth}px`;
    }
    setNotificationsWidth() {
        this.notificationsList.style.width = `${this.rootDOM.offsetWidth / 3}px`;
    }
    resolveAndSetNameInputWidth() {
        const currentInputValue = this.menubarNameInput.value;
        this.menubarNameShadowElement.innerText = currentInputValue;
        const nameWidth = this.menubarNameShadowElement.getBoundingClientRect().width;
        const totalSpacing = (this.menubarCenteringOffset * 2) + (this.spacerWidth * 4);
        const totalUnoverlappingWidth = nameWidth + totalSpacing;
        if (totalUnoverlappingWidth >= this.rootDOM.clientWidth) {
            const forcedWidth = `${this.rootDOM.clientWidth - totalSpacing}px`;
            this.menubarNameInput.style.width = forcedWidth;
        }
        else {
            this.menubarNameShadowElement.style.width = `auto`;
            const shadowRect = this.menubarNameShadowElement.getBoundingClientRect();
            this.menubarNameInput.style.width = `${shadowRect.width}px`;
        }
    }
    scrollFooterMessagesToBottom() {
        const lastMessage = this.footerBarMessagesList.children[this.footerBarMessagesList.children.length - 1];
        if (lastMessage !== undefined) {
            lastMessage.scrollIntoView(false);
        }
    }
    postNameChangedMessage() {
        var _a, _b;
        try {
            if (((_b = (_a = window) === null || _a === void 0 ? void 0 : _a.chrome) === null || _b === void 0 ? void 0 : _b.webview) !== undefined) {
                // @ts-ignore
                window.chrome.webview.postMessage({
                    status: 'OK',
                    operation: 'saveName',
                    data: {
                        name: this.name
                    }
                });
            }
        }
        catch (error) {
            console.error(error);
        }
    }
    /* Start Regex Helper methods */
    applyRegexViewMatchInfo(id, regexMatchInfo) {
        const regexHelperView = this.regexHelperViews[id];
        if (regexHelperView === undefined) {
            console.error(`A regex view with id ${id} doesn't exist.`);
            return;
        }
        this.refreshRegexHelperMatches(regexHelperView, regexMatchInfo);
        this.refreshRightHandSideEscapedRegexInMainEditor(regexHelperView);
    }
    applyResolvedSubjectStringToContinueRegexHelperAdd(id, subjectString) {
        const editorSingleton = JADEConfigurationEditor.getMonacoEditorSingleton();
        const regexHelperView = this.regexHelperViews[id];
        this.monacoEditor.changeViewZones((changeAccessor) => {
            regexHelperView.viewZoneId = changeAccessor.addZone(regexHelperView.zoneParams);
            // There isn't a promise on `changeViewZones`, so the only way to run after `addZone` is to put the logic here
            const subjectStringEditorMonacoModel = editorSingleton.createModel(subjectString, '');
            regexHelperView.subjectStringEditor = editorSingleton.create(regexHelperView.zoneParams.domNode.getElementsByClassName('subject-string-editor')[0], {
                model: subjectStringEditorMonacoModel,
                // override the vs-dark theme to be our custom dark theme
                theme: (this.theme === 'vs-dark') ? 'vs-dark-extended' : this.theme,
                scrollBeyondLastLine: false,
                showFoldingControls: "never",
                minimap: { enabled: false },
                scrollbar: { verticalScrollbarSize: 10 },
                lineNumbers: 'off'
            });
            const matches = regexHelperView.line.match(this.regexLineRegex);
            if (matches === null) {
                console.error(`${regexHelperView.line} does not contain a valid value`);
                return;
            }
            const rightHandSideRegexString = matches[2];
            if (rightHandSideRegexString === undefined) {
                console.error(`${regexHelperView.line} right hand side does not contain a valid value`);
                return;
            }
            const unescapedRegexValue = JSON.parse(rightHandSideRegexString);
            const regexEditorMonacoModel = editorSingleton.createModel(unescapedRegexValue, 'regexLanguage');
            regexHelperView.regexEditor = editorSingleton.create(regexHelperView.zoneParams.domNode.getElementsByClassName('regex-input-editor')[0], {
                model: regexEditorMonacoModel,
                // override the vs-dark theme to be our custom dark theme
                theme: (this.theme === 'vs-dark') ? 'vs-dark-extended' : this.theme,
                scrollBeyondLastLine: false,
                showFoldingControls: "never",
                minimap: { enabled: false },
                scrollbar: { verticalScrollbarSize: 10 },
                lineNumbers: 'off',
                language: 'regexLanguage',
            });
            regexHelperView.subjectStringEditor.onDidChangeModelContent(() => {
                this.evaluateRegex(regexHelperView);
            });
            regexHelperView.regexEditor.onDidChangeModelContent(() => {
                this.evaluateRegex(regexHelperView);
                // this is the pattern for turning the regex editor into a single line editor
                // if (regexHelperView.regexEditorContents !== regexHelperView.regexEditor!.getValue()) {
                //     const position = regexHelperView.regexEditor!.getPosition();
                //     regexHelperView.regexEditorContents = regexHelperView.regexEditor!.getValue().replace(/[\n\r]/g, '');
                //     regexHelperView.regexEditor!.setValue(regexHelperView.regexEditorContents);
                //     regexHelperView.regexEditor!.setPosition(position!)
                // }
            });
        });
        // wait 20ms before forcing a layout of the editors
        setTimeout(() => {
            const layoutInfo = this.monacoEditor.getLayoutInfo();
            const viewWidth = layoutInfo.minimap.minimapLeft - layoutInfo.lineNumbersWidth - layoutInfo.glyphMarginWidth - layoutInfo.decorationsWidth;
            const editorWidths = viewWidth - 250 - 10;
            regexHelperView.zoneParams.domNode.style.width = `${viewWidth}px`;
            const testStringContainerEl = regexHelperView.zoneParams.domNode.getElementsByClassName('subject-string-container')[0];
            const regexInputContainerEl = regexHelperView.zoneParams.domNode.getElementsByClassName('regex-input-container')[0];
            testStringContainerEl.style.width = `${editorWidths}px`;
            regexInputContainerEl.style.width = `${editorWidths}px`;
            const testStringContainerElBoundingRect = testStringContainerEl.getBoundingClientRect();
            const regexInputContainerElBoundingRect = regexInputContainerEl.getBoundingClientRect();
            regexHelperView.subjectStringEditor.layout({ width: editorWidths, height: testStringContainerElBoundingRect.height });
            regexHelperView.regexEditor.layout({ width: editorWidths, height: regexInputContainerElBoundingRect.height });
            this.evaluateRegex(regexHelperView);
        }, 20);
    }
    evaluateSubjectString(regexHelperView, subjectString) {
        var _a, _b;
        try {
            if (((_b = (_a = window) === null || _a === void 0 ? void 0 : _a.chrome) === null || _b === void 0 ? void 0 : _b.webview) !== undefined) {
                // @ts-ignore
                window.chrome.webview.postMessage({
                    status: 'OK',
                    operation: 'evaluateSubjectString',
                    data: {
                        id: regexHelperView.id,
                        subjectString
                    }
                });
            }
        }
        catch (error) {
            console.error(error);
        }
        // UNCOMMENT to test without LV backend
        this.applyResolvedSubjectStringToContinueRegexHelperAdd(regexHelperView.id, subjectString);
        // END UNCOMMENT
    }
    evaluateRegex(regexHelperView) {
        var _a, _b;
        const subjectString = regexHelperView.subjectStringEditor.getValue();
        const regexString = regexHelperView.regexEditor.getValue();
        try {
            if (((_b = (_a = window) === null || _a === void 0 ? void 0 : _a.chrome) === null || _b === void 0 ? void 0 : _b.webview) !== undefined) {
                // @ts-ignore
                window.chrome.webview.postMessage({
                    status: 'OK',
                    operation: 'evaluateRegex',
                    data: {
                        id: regexHelperView.id,
                        subjectString,
                        regexString
                    }
                });
            }
        }
        catch (error) {
            console.error(error);
        }
        // UNCOMMENT to test with hacked JS regex
        // const regex = new RegExp(regexString);
        // const found = regex.test(subjectString);
        // const match = { text: subjectString, index: 0, length: subjectString.length }
        // const submatches = [
        //     { text: subjectString, index: 1, length: subjectString.length }
        // ]
        // this.applyRegexViewMatchInfo(regexHelperView.id, {
        //     found,
        //     match,
        //     submatches
        // });
        // END UNCOMMENT
    }
    generateSubmatchHighlightClassName(regexHelperViewId, submatchIndex) {
        return `regex-helper-${regexHelperViewId}-editor-highlight-${submatchIndex}`;
    }
    refreshRegexHelperMatches(regexHelperView, regexMatchInfo) {
        if (regexHelperView.subjectStringEditorDecorations !== undefined) {
            regexHelperView.subjectStringEditorDecorations.clear();
        }
        if (regexHelperView.stylesheet !== undefined) {
            regexHelperView.stylesheet.remove();
        }
        const colors = (0, randomcolor_1.default)({ format: 'rgb', hue: 'yellow', seed: 9, luminosity: 'light', count: regexMatchInfo.submatches.length });
        const stylesheetContents = colors
            .map((color, i) => {
            const className = this.generateSubmatchHighlightClassName(regexHelperView.id, i);
            return `
                    .${className} {
                        background-color: #1e1e1e;
                        color: white;
                        border: 1px solid ${color};
                    }

                    .${className}-editor-highlight {
                        background-color: ${color};
                        color: #1e1e1e;
                    }

                    .${className} > .index {
                        background: ${color};
                    }

                    .${className} > .copy-button {
                        color: ${color};
                        fill: ${color};
                    }
                `;
        })
            .join('\n');
        regexHelperView.stylesheet = document.createElement('style');
        regexHelperView.stylesheet.innerHTML = stylesheetContents;
        document.head.append(regexHelperView.stylesheet);
        regexHelperView.matchDisplayEl.innerHTML = `
            <div class="${regexMatchInfo.found === false ? 'regex-helper-match-not-found' : 'regex-helper-match'}">
                ${regexMatchInfo.found ? regexMatchInfo.match.text : 'NOT FOUND'}
            </div>
        `;
        regexHelperView.submatchesDisplayEl.innerHTML = regexMatchInfo.submatches
            .map((submatch, i) => {
            const value = `submatch[${i}]`;
            return `
                    <div class="regex-helper-submatch ${this.generateSubmatchHighlightClassName(regexHelperView.id, i)}" data-value="${value}">
                        <div class="index">${i}</div>
                        <div class="submatch">${value}</div>
                        <div class="copy-button">${copy_svg_1.default}</div>
                    </div>
                `;
        })
            .join('\n');
        let transformedRanges;
        const subjectString = regexHelperView.subjectStringEditor.getValue();
        const highlightDecorations = [];
        try {
            transformedRanges = (0, regex_1.regexTransformMatchInfoToRangeInfo)(subjectString, regexMatchInfo);
        }
        catch (error) {
            console.error(error);
            return;
        }
        for (let i = 0; i < transformedRanges.submatches.length; i++) {
            const range = transformedRanges.submatches[i];
            highlightDecorations.push({
                range: new monaco_editor_1.Range(range.startLineNumber, range.startColumn, range.endLineNumber, range.endColumn + 1),
                options: {
                    inlineClassName: `${this.generateSubmatchHighlightClassName(regexHelperView.id, i)}-editor-highlight`,
                }
            });
        }
        regexHelperView.subjectStringEditorDecorations = regexHelperView.subjectStringEditor.createDecorationsCollection(highlightDecorations);
    }
    refreshRightHandSideEscapedRegexInMainEditor(regexHelperView) {
        const regexEditorContent = regexHelperView.regexEditor.getValue();
        const escapedRegex = JSON.stringify(regexEditorContent);
        const jsonEditorContent = this.getContent();
        const jsonContentLines = jsonEditorContent.split('\n');
        const lineNumber = regexHelperView.zoneParams.afterLineNumber;
        const lineContent = jsonContentLines[lineNumber];
        const match = this.regexLineRegex.exec(lineContent);
        if (match === null) {
            console.error(`Line ${lineNumber} does not match the regular expression field pattern`);
            return;
        }
        const startOfLine = lineContent.substring(0, match.index + match[1].length);
        const endOfLine = lineContent.substring(match.index + match[1].length + match[2].length);
        const newLineContent = `${startOfLine}${escapedRegex}${endOfLine}`;
        this.monacoEditor.executeEdits("my-source", [{ range: new monaco_editor_1.Range(lineNumber + 1, 1, lineNumber + 1, lineContent.length + 1), text: newLineContent }]);
        regexHelperView.line = newLineContent;
    }
    addRegexHelperView(lineNumber) {
        const matchingSchema = this.regexHelperMatchingSchemas[lineNumber];
        const line = this.monacoEditor.getModel().getLineContent(lineNumber);
        // @ts-expect-error we've added fields to the schema so ignore error
        const id = matchingSchema.schema.regexHelper.id;
        const domNode = document.createElement('div');
        const marginDomNode = document.createElement("div");
        domNode.setAttribute('data-regex-helper-id', id);
        marginDomNode.setAttribute('data-regex-helper-id', id);
        domNode.classList.add('regex-helper-view');
        marginDomNode.classList.add('regex-helper-margin-view');
        domNode.addEventListener('click', this.onRegexHelperClick);
        marginDomNode.addEventListener('click', this.onRegexHelperMarginClick);
        domNode.innerHTML = `
            <div class="regex-helper-view-container">
                <div class="subject-string-container">
                    <div class="subject-string-editor"></div>
                </div>
                <div class="regex-input-container">
                    <div class="regex-input-editor"></div>
                </div>
                <div class="regex-matches-container">
                    <div class="regex-match-label">MATCH</div>
                    <div class="regex-match-display"></div>
                    <div class="regex-match-label">SUBMATCHES</div>
                    <div class="regex-submatches-display"></div>
                </div>
            </div>
            <div class="regex-helper-view-close-button">
                ${xmark_svg_1.default}
            </div>
        `;
        marginDomNode.innerHTML = `
            <div class="regex-helper-margin-view-container">
                <div class="subject-string-label">
                    SUBJECT STRING
                </div>
                <div class="regex-input-label">
                    REGEX
                </div>
            </div>
        `;
        const zoneParams = {
            afterLineNumber: lineNumber - 1,
            heightInLines: 16,
            domNode,
            marginDomNode,
            suppressMouseDown: false
        };
        const regexHelperView = {
            id,
            line,
            zoneParams,
            matchDisplayEl: domNode.getElementsByClassName('regex-match-display')[0],
            submatchesDisplayEl: domNode.getElementsByClassName('regex-submatches-display')[0]
        };
        this.regexHelperViews[regexHelperView.id] = regexHelperView;
        // @ts-expect-error we add extra fields to support the regex helper
        let subjectStringValue = matchingSchema.schema.regexHelper.defaultSubjectString !== undefined ? matchingSchema.schema.regexHelper.defaultSubjectString : '';
        if (matchingSchema.node.parent !== undefined) {
            if (matchingSchema.node.parent.parent !== undefined && matchingSchema.node.parent.parent.type === 'object') {
                matchingSchema.node.parent.parent.properties.forEach((property) => {
                    // @ts-expect-error we add extra fields to support the regex helper
                    if (matchingSchema.schema.regexHelper.injectSubjectStringFromPropertyWithKey !== undefined && property.keyNode.value === matchingSchema.schema.regexHelper.injectSubjectStringFromPropertyWithKey) {
                        subjectStringValue = property.valueNode.value;
                    }
                });
            }
        }
        this.evaluateSubjectString(regexHelperView, subjectStringValue);
    }
    removeRegexHelperView(regexHelperView) {
        this.monacoEditor.changeViewZones((changeAccessor) => {
            changeAccessor.removeZone(regexHelperView.viewZoneId);
            regexHelperView.zoneParams.domNode.removeEventListener('click', this.onRegexHelperClick);
        });
        delete this.regexHelperViews[regexHelperView.id];
    }
    async applyRegexDecorations(contentBuffer) {
        if (this.regexHelperDecorations !== undefined) {
            this.regexHelperDecorations.clear();
        }
        const workerAccessor = await monaco_editor_1.languages.json.getWorker();
        const worker = await workerAccessor(this.monacoModelUri);
        const matchingSchemas = await worker.getMatchingSchemas(this.monacoModelUri.toString());
        const lines = [];
        for (let i = 0; i < matchingSchemas.length; i++) {
            const matchingSchema = matchingSchemas[i];
            // @ts-expect-error we add an extra property to the schema to turn on regexHelper use, so ignore TS error
            if (matchingSchema.schema.regexHelper !== undefined && matchingSchema.schema.regexHelper.enable === true) {
                const position = this.monacoEditor.getModel().getPositionAt(matchingSchema.node.offset);
                this.regexHelperMatchingSchemas[position.lineNumber] = matchingSchema;
                lines.push(position.lineNumber);
                Object.values(this.regexHelperViews).forEach((regexHelperView) => {
                    // @ts-expect-error we add an extra property to the schema to turn on regexHelper use, so ignore TS error
                    if (regexHelperView.id === matchingSchema.schema.regexHelper.id) {
                        this.monacoEditor.changeViewZones(function (changeAccessor) {
                            regexHelperView.zoneParams.afterLineNumber = position.lineNumber - 1;
                            changeAccessor.layoutZone(regexHelperView.viewZoneId);
                        });
                    }
                });
            }
        }
        const linesToDecorate = lines.map((lineNumber) => {
            return {
                range: new monaco_editor_1.Range(lineNumber, 1, lineNumber, 1),
                options: {
                    isWholeLine: true,
                    linesDecorationsClassName: "regex-line",
                }
            };
        });
        this.regexHelperDecorations = this.monacoEditor.createDecorationsCollection(linesToDecorate);
    }
    decorateSchema(obj) {
        for (let key in obj) {
            if (typeof obj[key] === 'object') {
                if (Array.isArray(obj[key])) {
                    for (let i = 0; i < obj[key].length; i++) {
                        this.decorateSchema(obj[key][i]);
                    }
                }
                else {
                    if (key === 'regexHelper') {
                        this.regexHelperIdUniquenessCounter = this.regexHelperIdUniquenessCounter + 1;
                        obj[key].id = `regex-helper-${this.regexHelperIdUniquenessCounter}`;
                    }
                    else {
                        this.decorateSchema(obj[key]);
                    }
                }
            }
        }
    }
    decorateSchemaWithFeatureParams(jsonSchema) {
        this.decorateSchema(jsonSchema);
        return jsonSchema;
    }
    async onRegexHelperClick(event) {
        let eventTarget = event.target;
        event.stopPropagation();
        if (eventTarget.classList.contains('copy-button') || eventTarget.closest('.copy-button') !== null) {
            if (eventTarget.classList.contains('copy-button') === false) {
                eventTarget = eventTarget.closest('.copy-button');
            }
            const submatchEl = eventTarget.closest('.regex-helper-submatch');
            const valueToCopy = submatchEl.getAttribute('data-value');
            await navigator.clipboard.writeText(valueToCopy);
            const tippyInstance = (0, tippy_js_1.default)(eventTarget, {
                content: `Copied`,
                theme: 'regex-copy-message',
                appendTo: () => submatchEl,
                placement: 'top',
                hideOnClick: true,
                delay: [200, 200],
                trigger: 'manual'
            });
            tippyInstance.show();
            setTimeout(() => {
                tippyInstance.hide();
                setTimeout(() => {
                    tippyInstance.destroy();
                }, 200);
            }, 3000);
        }
        else if (eventTarget.classList.contains('regex-helper-view-close-button') || eventTarget.closest('.regex-helper-view-close-button') !== null) {
            const viewEl = eventTarget.closest('.regex-helper-view');
            const regexHelperId = viewEl.getAttribute('data-regex-helper-id');
            this.removeRegexHelperView(this.regexHelperViews[regexHelperId]);
        }
    }
    onRegexHelperMarginClick(event) {
        // stubbed in case we need to add any button behavior to the margin dom node
    }
    /* End Regex Helper methods */
    onFooterMessageRemove(messageToRemove) {
        var _a, _b;
        let index = -1;
        for (let i = 0; i < this.footerBarMessages.length; i++) {
            const message = this.footerBarMessages[i];
            if (message === messageToRemove) {
                index = i;
                this.footerBarMessages.splice(i, 1);
                this.renderFooterBar();
                break;
            }
        }
        try {
            if (((_b = (_a = window) === null || _a === void 0 ? void 0 : _a.chrome) === null || _b === void 0 ? void 0 : _b.webview) !== undefined) {
                // @ts-ignore
                window.chrome.webview.postMessage({
                    status: 'OK',
                    operation: 'removeFooterMessage',
                    data: {
                        messageIndex: index
                    }
                });
            }
        }
        catch (error) {
            console.error(error);
        }
    }
    onFooterMessagesClear() {
        var _a, _b;
        this.clearFooterMessages();
        try {
            if (((_b = (_a = window) === null || _a === void 0 ? void 0 : _a.chrome) === null || _b === void 0 ? void 0 : _b.webview) !== undefined) {
                // @ts-ignore
                window.chrome.webview.postMessage({
                    status: 'OK',
                    operation: 'clearFooterMessages',
                    data: {}
                });
            }
        }
        catch (error) {
            console.error(error);
        }
    }
    onResize() {
        this.render();
    }
    onKeyDown(event) {
        // important note: we stop propagation in each case below but NOT outside here.
        // this would prevent the keydown event from propagating to the monaco instance which then prevents actually typing!
        // in fact, this used to be a keyup event handler, but this caused a subtle bug where if you (like many of us do) quickly type ctrl + 's' (for example),
        // you'll lift the ctrl and 's' keys up just about at the same time and the browser will miss the key up operation on the 's' key while the actual
        // ctrl key was down and thus the logical condition below will not be met and save wouldn't happen
        if (event.ctrlKey === true) {
            switch (event.key) {
                case 's':
                case 'S':
                    this.saveContent();
                    event.preventDefault();
                    event.stopPropagation();
                    break;
                case 'y':
                case 'Y':
                    this.redo();
                    event.preventDefault();
                    event.stopPropagation();
                    break;
                case 'd':
                case 'D':
                    this.openDocumentation();
                    event.preventDefault();
                    event.stopPropagation();
                    break;
                case 'v':
                case 'V':
                    this.pasteWithFilter();
                    event.preventDefault();
                    event.stopPropagation();
                    break;
                default:
                    break;
            }
        }
        else if (event.altKey === true) {
            if (event.key === 'f' || event.key === 'F') {
                this.formatDocument();
                event.preventDefault();
                event.stopPropagation();
            }
            else if (event.key === 'z' || event.key === 'Z') {
                this.wordWrap();
                event.preventDefault();
                event.stopPropagation();
            }
            else if (event.code.startsWith('Digit')) {
                this.setFoldingLevel(parseInt(event.code.substring(5))); // 5 = index of the number in something like "Digit3"
                event.preventDefault();
                event.stopPropagation();
            }
        }
        // is enter key while editing name
        else if (this.isEditingName && event.code === 'Enter') {
            this.menubarNameInput.blur();
            event.preventDefault();
            event.stopPropagation();
        }
        // is escape key while editing name
        else if (this.isEditingName && event.code === 'Escape') {
            this.escapeKeyLiftedUpWhileEditingName = true;
            this.menubarNameInput.blur();
            event.preventDefault();
            event.stopPropagation();
        }
    }
    onBodyClick(event) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        const eventTarget = event.target;
        // if it's a click on a fold level from the tooltip menu
        if (eventTarget.classList.contains('fold-level')) {
            const level = parseInt(eventTarget.getAttribute('data-level'));
            this.setFoldingLevel(level);
            (_a = this.foldLevelTooltip) === null || _a === void 0 ? void 0 : _a.hide();
        }
        else if (eventTarget.classList.contains('zoom-direction')) {
            const direction = eventTarget.getAttribute('data-direction');
            (_b = this.zoomTooltip) === null || _b === void 0 ? void 0 : _b.hide();
            if (direction === 'in') {
                try {
                    if (((_d = (_c = window) === null || _c === void 0 ? void 0 : _c.chrome) === null || _d === void 0 ? void 0 : _d.webview) !== undefined) {
                        // @ts-ignore
                        window.chrome.webview.postMessage({
                            status: 'OK',
                            operation: 'zoomIn',
                            data: {}
                        });
                    }
                }
                catch (error) {
                    console.error(error);
                }
            }
            else {
                try {
                    if (((_f = (_e = window) === null || _e === void 0 ? void 0 : _e.chrome) === null || _f === void 0 ? void 0 : _f.webview) !== undefined) {
                        // @ts-ignore
                        window.chrome.webview.postMessage({
                            status: 'OK',
                            operation: 'zoomOut',
                            data: {}
                        });
                    }
                }
                catch (error) {
                    console.error(error);
                }
            }
        }
        else if (eventTarget.classList.contains('version')) {
            const version = eventTarget.getAttribute('data-version');
            // we disable this if this.hideVersionEditor is true so it may not exist and TS will complain if we don't case here (or use an @ts-ignore comment)
            if (this.versionSelectorTooltip !== undefined) {
                this.versionSelectorTooltip.hide();
            }
            else {
                console.log('We did not expect to get this line of code.  It should not be possible if this.versionSelectorTooltip is not defined in the first place.');
            }
            try {
                if (((_h = (_g = window) === null || _g === void 0 ? void 0 : _g.chrome) === null || _h === void 0 ? void 0 : _h.webview) !== undefined) {
                    // @ts-ignore
                    window.chrome.webview.postMessage({
                        status: 'OK',
                        operation: 'saveVersion',
                        data: {
                            version: version
                        }
                    });
                }
            }
            catch (error) {
                console.error(error);
            }
        }
        else if (eventTarget.classList.contains('regex-line')) {
            const lineNumbersEl = eventTarget.nextSibling;
            if (lineNumbersEl !== null) {
                const lineNumber = parseInt(lineNumbersEl.textContent);
                const existingRegexView = Object.values(this.regexHelperViews).find((regexHelperView) => {
                    return regexHelperView.zoneParams.afterLineNumber === lineNumber - 1;
                });
                if (existingRegexView !== undefined) {
                    this.removeRegexHelperView(existingRegexView);
                }
                else {
                    this.addRegexHelperView(lineNumber);
                }
            }
        }
    }
    onFooterbarStartDrag(event) {
        this.clientYOnFooterStartDrag = event.clientY;
        this.footerBarMessagesListHeightOnFooterStartDrag = this.footerBarMessagesList.offsetHeight; // the height attribute is always set (we initialize it in the constructor)
        this.editorDOMHeightOnStartDrag = this.editorDOM.offsetHeight;
        this.rootDOM.style.cursor = 'ns-resize';
        window.addEventListener('mousemove', this.onFooterbarDrag);
        window.addEventListener('mouseup', this.onFooterbarEndDrag);
    }
    onFooterbarDrag(event) {
        var _a;
        // resolve the bounded new height
        let newHeight = this.footerBarMessagesListHeightOnFooterStartDrag - (event.clientY - this.clientYOnFooterStartDrag); // remember the browser y axis increases as you go down the page, which is abhorrent ;-)
        if (newHeight <= 0) { // yeah, this is redundant for the 0 case, but if we don't do <= here then the else case will execute and that's more work for the CPU which is undesireable
            newHeight = 0;
        }
        else {
            // note: this.editorDOMHeightOnStartDrag is the height of the editable portion, not the height of the entire "editor" as rendered.  this changes as we resize the footer area
            const maxAllowedHeight = this.editorDOMHeightOnStartDrag + this.footerBarMessagesListHeightOnFooterStartDrag - 20; // don't go past 20px from the top so you can always see a little bit of the edtior behind
            if (newHeight > maxAllowedHeight) {
                newHeight = maxAllowedHeight;
            }
        }
        // set other parameters which are based on
        if (newHeight > 0) {
            this.footerBarDraggedHeight = newHeight;
            this.footerBarIsExpanded = true;
        }
        else {
            this.footerBarDraggedHeight = undefined;
            this.footerBarIsExpanded = false;
        }
        (_a = window.getSelection()) === null || _a === void 0 ? void 0 : _a.empty();
        this.renderFooterBarExpandedStatusIcon();
        this.renderFooterVerticalSizing(newHeight);
    }
    onFooterbarEndDrag(event) {
        this.rootDOM.style.cursor = 'initial';
        window.removeEventListener('mousemove', this.onFooterbarDrag);
        window.removeEventListener('mouseup', this.onFooterbarEndDrag);
    }
    onFooterbarMaintainScrollToBottomIconClick(event) {
        this.footerBarIsMaintainingScrollToBottom = !this.footerBarIsMaintainingScrollToBottom;
        this.renderFooterBarMaintainScrollToBottomIcon();
        if (this.footerBarIsMaintainingScrollToBottom) {
            this.scrollFooterMessagesToBottom();
        }
    }
    onFooterbarExpandedStatusIconClick(event) {
        let footerBarMessagesListHeight = 0;
        this.footerBarIsExpanded = !this.footerBarIsExpanded;
        if (this.footerBarIsExpanded) {
            footerBarMessagesListHeight = this.footerBarDraggedHeight !== undefined ? this.footerBarDraggedHeight : this.footerBarDefaultExpansionHeight;
        }
        this.renderFooterBarExpandedStatusIcon();
        this.renderFooterVerticalSizing(footerBarMessagesListHeight);
    }
    onNameInputMouseOver(event) {
        this.menubarNameInput.style.borderColor = (0, color_1.default)(this.menubarBorderColor).alpha(.75).desaturate(0).toString();
    }
    onNameInputMouseOut(event) {
        if (this.isEditingName === false) {
            this.menubarNameInput.style.borderColor = (0, color_1.default)(this.menubarBorderColor).alpha(.1).desaturate(.5).toString();
        }
    }
    onNameInputChange(event) {
        this.resolveAndSetNameInputWidth();
    }
    onNameInputFocus(event) {
        this.isEditingName = true;
        this.nameOnFocus = this.menubarNameInput.value.trimStart().trimEnd();
    }
    onNameInputBlur(event) {
        const oldName = this.nameOnFocus;
        const newName = this.menubarNameInput.value.trimStart().trimEnd();
        // if the escape key is pressed while editing, go back to the original name regardless
        if (this.escapeKeyLiftedUpWhileEditingName || newName === '') {
            this.escapeKeyLiftedUpWhileEditingName = false;
            this.menubarNameInput.value = oldName;
            if (this.isValidName(oldName)) {
                this.updateUI_inputNameValid();
            }
            else {
                this.updateUI_inputNameInvalid(oldName);
            }
        }
        // otherwise if the name is valid, update accordingly
        else if (this.isValidName(newName)) {
            this.name = newName;
            this.menubarNameInput.value = this.name;
            this.menubarNameShadowElement.innerText = this.name;
            if (newName !== oldName) {
                this.postNameChangedMessage();
            }
        }
        // return to the "not editing" state
        this.isEditingName = false;
        this.resolveAndSetNameInputWidth();
        this.onNameInputMouseOut();
    }
    onNameInputKeyUp(event) {
        const prospectiveName = this.menubarNameInput.value.trimStart().trimEnd();
        if (this.isValidName(prospectiveName)) {
            this.updateUI_inputNameValid();
        }
        else {
            this.updateUI_inputNameInvalid(prospectiveName);
        }
    }
    updateUI_inputNameValid() {
        this.menubarNameInput.style.backgroundColor = 'transparent';
        this.menubarNameInput.style.color = this.menubarIconColor;
        this.removeNotification(this.nameErrorNotificationId); // remove the name error notification if there is one
    }
    updateUI_inputNameInvalid(invalidInstanceName) {
        this.menubarNameInput.style.backgroundColor = this.errorColor;
        this.menubarNameInput.style.color = this.notificationColor;
        const message = `Invalid instance name: "${invalidInstanceName}"\n\nInstance names cannot contain the following characters:\n\n. [ ] " / \\ <backspace> <form feed> <line feed> <carriage return> <tab>\n\nThe instance name has not been updated.`;
        console.error(message);
        this.removeNotification(this.nameErrorNotificationId); // remove the notification if there is one since we'll add another below (and we only want 1 of these at a time)
        this.nameErrorNotificationId = this.addNotification(message, 'error');
    }
    onMarkersChange(modelURIs) {
        const markers = monaco_editor_1.editor.getModelMarkers({
            resource: this.monacoModelUri
        });
        this.footerBarMessages = [];
        for (let i = 0; i < markers.length; i++) {
            const marker = markers[i];
            let type = 'error';
            switch (marker.severity) {
                case monaco_editor_1.MarkerSeverity.Warning:
                    type = 'warning';
                    break;
                case monaco_editor_1.MarkerSeverity.Info:
                    type = 'note';
                    break;
            }
            const message = {
                type,
                duplicity: 1,
                cells: [
                    {
                        text: marker.message,
                        fraction: .66
                    },
                    {
                        text: `L${marker.startLineNumber}:C${marker.startColumn} - L${marker.endLineNumber}:C${marker.endColumn}`,
                        fraction: .33
                    }
                ],
                clearable: false,
                onClick: (event) => {
                    this.monacoEditor.setSelection({
                        startLineNumber: marker.startLineNumber,
                        startColumn: marker.startColumn,
                        endLineNumber: marker.endLineNumber,
                        endColumn: marker.endColumn
                    });
                    this.monacoEditor.focus();
                }
            };
            this.footerBarMessages.push(message);
        }
        this.renderFooterBar();
    }
    onChange(changeEvent) {
        var _a, _b;
        const currentContent = this.getContent();
        const currentContentSize = currentContent.length;
        const lastSavedContentSize = this.lastSavedContent.length;
        this.applyRegexDecorations(currentContent);
        try {
            if (((_b = (_a = window) === null || _a === void 0 ? void 0 : _a.chrome) === null || _b === void 0 ? void 0 : _b.webview) !== undefined) {
                // @ts-ignore
                window.chrome.webview.postMessage({
                    status: 'OK',
                    operation: 'updateContent',
                    data: {
                        contentChanged: (currentContentSize !== lastSavedContentSize) || (currentContent !== this.lastSavedContent)
                    }
                });
            }
        }
        catch (error) {
            console.error(error);
        }
    }
    async pasteWithFilter() {
        /***************************************/
        /*********** FILTER CONTENTS ***********/
        /***************************************/
        var _a, _b, _c, _d, _e;
        // get the current clipboard contents and filter it (i.e. replace "illegal" characters accordingly)
        let text = await navigator.clipboard.readText();
        let filteredText = '';
        const lookupReplacements = {};
        const unknownReplacements = {};
        const unknownReplacementChar = '#';
        const length = text.length;
        for (let i = 0; i < length; i++) {
            const char = text[i];
            if (this.pasteAllowRegex.test(char) === true) {
                filteredText += char;
            }
            else {
                let replacement = this.pasteReplacementLookup[char];
                if (replacement !== undefined) {
                    filteredText += replacement;
                    lookupReplacements[char] = replacement;
                }
                else {
                    filteredText += unknownReplacementChar; // replace unknown with #
                    unknownReplacements[char] = unknownReplacementChar;
                }
            }
        }
        /*****************************************************/
        /*********** FIND TARGET ELEMENT AND PASTE ***********/
        /*****************************************************/
        // capture the active element which we'll use to determine where we are
        const activeElement = document.activeElement;
        // first determine if we're in a search / find field
        let findField = activeElement === null || activeElement === void 0 ? void 0 : activeElement.closest('div.monaco-findInput');
        if (findField !== undefined && findField !== null) {
            if (((_a = activeElement === null || activeElement === void 0 ? void 0 : activeElement.nodeName) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === 'textarea') {
                const textAreaElement = activeElement;
                const value = textAreaElement.value;
                const beforeSelection = value.substring(0, textAreaElement.selectionStart);
                const afterSelection = value.substring(textAreaElement.selectionEnd);
                textAreaElement.value = beforeSelection + filteredText + afterSelection;
                textAreaElement.selectionEnd = beforeSelection.length + filteredText.length;
            }
        }
        else { // otherwise determine and handle which editor instance we're pasting into (main vs a regex helper field)
            // to start, assume we're pasting into the main monaco editor instance
            let pasteToEditor = this.monacoEditor;
            // now let's check if, in fact, we were actually pasting into a regex helper instance (subject string field or regex field)
            let regexHelperId = (_c = (_b = activeElement === null || activeElement === void 0 ? void 0 : activeElement.closest('div.regex-input-container')) === null || _b === void 0 ? void 0 : _b.closest('div.regex-helper-view')) === null || _c === void 0 ? void 0 : _c.getAttribute('data-regex-helper-id');
            if (regexHelperId !== undefined && regexHelperId !== null) {
                pasteToEditor = this.regexHelperViews[regexHelperId].regexEditor;
            }
            else {
                regexHelperId = (_e = (_d = activeElement === null || activeElement === void 0 ? void 0 : activeElement.closest('div.subject-string-container')) === null || _d === void 0 ? void 0 : _d.closest('div.regex-helper-view')) === null || _e === void 0 ? void 0 : _e.getAttribute('data-regex-helper-id');
                if (regexHelperId !== undefined && regexHelperId !== null) {
                    pasteToEditor = this.regexHelperViews[regexHelperId].subjectStringEditor;
                }
            }
            // bring the editor to focus, just in case
            pasteToEditor.focus();
            // get the current selection in the editor
            const selection = pasteToEditor.getSelection();
            if (!selection) {
                return;
            }
            // replace the current contents with the filteredText from the clipboard
            pasteToEditor.executeEdits("clipboard", [{
                    range: selection,
                    text: filteredText,
                    forceMoveMarkers: true,
                }]);
        }
        /******************************************************/
        /*********** IF FILTERED, CONSTRUCT MESSAGE ***********/
        /******************************************************/
        // construct a message indicating whaich characters were filtered
        const allReplacements = Object.assign(lookupReplacements, unknownReplacements);
        let replacementsMessage = '';
        for (const char in allReplacements) {
            replacementsMessage += `'${char}' --> '${allReplacements[char]}'\n`;
        }
        // if any filtering occurred (i.e. we have replacements), notify the user
        if (replacementsMessage.length > 0) {
            replacementsMessage = replacementsMessage.substring(0, replacementsMessage.length - 1);
            const message = `The pasted content contained characters which are not allowed.  The following replacements have been made to sterilize the pasted content:\n\nFormat: original --> replacement\n\n${replacementsMessage}`;
            this.addNotification(message, "warning");
        }
    }
}
exports.JADEConfigurationEditor = JADEConfigurationEditor;
JADEConfigurationEditor.monacoEditorInitialized = false;
